var map = {
	"./FariaOne-icon": 1402,
	"./FariaOne-icon.png": 1402,
	"./KBL": 1210,
	"./KBL.png": 1210,
	"./ajax-loader": 177,
	"./ajax-loader.gif": 177,
	"./alert": 1403,
	"./alert.svg": 1403,
	"./arrow": 1393,
	"./arrow-bottom-right": 1394,
	"./arrow-bottom-right.png": 1394,
	"./arrow-right-bottom": 1395,
	"./arrow-right-bottom.png": 1395,
	"./arrow.svg": 1393,
	"./blue-clock": 1396,
	"./blue-clock.svg": 1396,
	"./blue-mail": 1397,
	"./blue-mail.svg": 1397,
	"./blue-trash": 1398,
	"./blue-trash.svg": 1398,
	"./blue_trash": 1390,
	"./blue_trash.svg": 1390,
	"./calendar": 1184,
	"./calendar.svg": 1184,
	"./certification_page/accordion_closed": 1211,
	"./certification_page/accordion_closed.svg": 1211,
	"./certification_page/accordion_open": 1212,
	"./certification_page/accordion_open.svg": 1212,
	"./certification_page/accordion_open_rotated": 1213,
	"./certification_page/accordion_open_rotated.svg": 1213,
	"./certification_page/banner-image-managebac-certified-educator": 608,
	"./certification_page/banner-image-managebac-certified-educator.svg": 608,
	"./certification_page/banner-image-managebac-training-academy": 609,
	"./certification_page/banner-image-managebac-training-academy.svg": 609,
	"./certification_page/breadcrumbs-certification": 1214,
	"./certification_page/breadcrumbs-certification.png": 1214,
	"./certification_page/checkbox_checked": 1215,
	"./certification_page/checkbox_checked.svg": 1215,
	"./certification_page/checkbox_unchecked": 1216,
	"./certification_page/checkbox_unchecked.svg": 1216,
	"./certification_page/checkmark": 1217,
	"./certification_page/checkmark.svg": 1217,
	"./certification_page/communitea": 1218,
	"./certification_page/communitea.png": 1218,
	"./certification_page/conference_apac": 1219,
	"./certification_page/conference_apac.png": 1219,
	"./certification_page/conference_generic": 1220,
	"./certification_page/conference_generic.svg": 1220,
	"./certification_page/conference_iba": 1221,
	"./certification_page/conference_iba.png": 1221,
	"./certification_page/cp": 1222,
	"./certification_page/cp.svg": 1222,
	"./certification_page/dp": 1223,
	"./certification_page/dp.svg": 1223,
	"./certification_page/duration-icon": 1224,
	"./certification_page/duration-icon.svg": 1224,
	"./certification_page/in-person-icon": 1225,
	"./certification_page/in-person-icon.svg": 1225,
	"./certification_page/induction_course_banner": 1226,
	"./certification_page/induction_course_banner.svg": 1226,
	"./certification_page/mb_logo": 1227,
	"./certification_page/mb_logo.svg": 1227,
	"./certification_page/multi-curricula": 1228,
	"./certification_page/multi-curricula.svg": 1228,
	"./certification_page/myp": 1229,
	"./certification_page/myp.svg": 1229,
	"./certification_page/pyp": 1230,
	"./certification_page/pyp.svg": 1230,
	"./certification_page/quote-close": 1231,
	"./certification_page/quote-close.svg": 1231,
	"./certification_page/quote-open": 1232,
	"./certification_page/quote-open.svg": 1232,
	"./certification_page/tag_invite_only": 1233,
	"./certification_page/tag_invite_only.svg": 1233,
	"./certification_page/unit-icon": 1234,
	"./certification_page/unit-icon.svg": 1234,
	"./checkbox": 1185,
	"./checkbox-checked": 1186,
	"./checkbox-checked.png": 1186,
	"./checkbox.png": 1185,
	"./close": 1388,
	"./close.svg": 1388,
	"./community/badge-atlas-contributor": 372,
	"./community/badge-atlas-contributor.png": 372,
	"./community/badge-certified-educator": 373,
	"./community/badge-certified-educator.png": 373,
	"./community/badge-community-ambassador": 374,
	"./community/badge-community-ambassador.png": 374,
	"./community/badge-community-pioneer": 375,
	"./community/badge-community-pioneer.png": 375,
	"./community/badge-conference-speaker": 376,
	"./community/badge-conference-speaker.png": 376,
	"./community/badge-content-leader": 377,
	"./community/badge-content-leader.png": 377,
	"./community/badge-iab-contributor": 378,
	"./community/badge-iab-contributor.png": 378,
	"./community/badge-managebac-certified-educator": 379,
	"./community/badge-managebac-certified-educator.png": 379,
	"./community/badge-managebac-community-ambassador": 380,
	"./community/badge-managebac-community-ambassador.png": 380,
	"./community/badge-managebac-community-pioneer": 381,
	"./community/badge-managebac-community-pioneer.png": 381,
	"./community/badge-managebac-subject-leader": 382,
	"./community/badge-managebac-subject-leader.png": 382,
	"./community/badge-managebac-training-academy": 383,
	"./community/badge-managebac-training-academy.png": 383,
	"./community/badge-minidp-coach": 384,
	"./community/badge-minidp-coach.png": 384,
	"./community/badge-minidp-course-designer": 385,
	"./community/badge-minidp-course-designer.png": 385,
	"./community/badge-minipd-coach": 386,
	"./community/badge-minipd-coach.png": 386,
	"./community/badge-minipd-course-design": 387,
	"./community/badge-minipd-course-design.png": 387,
	"./community/badge-minipd-course-designer": 388,
	"./community/badge-minipd-course-designer.png": 388,
	"./community/badge-openapply-contributor": 389,
	"./community/badge-openapply-contributor.png": 389,
	"./community/badge-osc-content-leader": 390,
	"./community/badge-osc-content-leader.png": 390,
	"./community/badge-osc-contributor": 391,
	"./community/badge-osc-contributor.png": 391,
	"./community/badge-osc-teacher": 392,
	"./community/badge-osc-teacher.png": 392,
	"./community/badge-osc-tutor": 393,
	"./community/badge-osc-tutor.png": 393,
	"./community/badge-osc-tutuor": 394,
	"./community/badge-osc-tutuor.png": 394,
	"./community/badge-pamoja-educator": 395,
	"./community/badge-pamoja-educator.png": 395,
	"./community/badge-pamoja-sbc-ambassador": 396,
	"./community/badge-pamoja-sbc-ambassador.png": 396,
	"./community/badge-pamoja-thought-leader": 397,
	"./community/badge-pamoja-thought-leader.png": 397,
	"./community/badge-schoolsbuddy-contributor": 398,
	"./community/badge-schoolsbuddy-contributor.png": 398,
	"./community/badge-schoolstechnology-contributor": 399,
	"./community/badge-schoolstechnology-contributor.png": 399,
	"./community/badge-schooltechnology-contributor": 400,
	"./community/badge-schooltechnology-contributor.png": 400,
	"./community/badge-subject-leader": 401,
	"./community/badge-subject-leader.png": 401,
	"./community/badge-training-academy": 402,
	"./community/badge-training-academy.png": 402,
	"./community/banner-community": 336,
	"./community/banner-community.png": 336,
	"./community/breadcrumbs-faria": 403,
	"./community/breadcrumbs-faria.png": 403,
	"./community/chantelle": 404,
	"./community/chantelle.png": 404,
	"./community/chevron-right": 405,
	"./community/chevron-right.png": 405,
	"./community/community-banner": 406,
	"./community/community-banner.png": 406,
	"./community/email-logo": 407,
	"./community/email-logo.png": 407,
	"./community/facebook-logo": 408,
	"./community/facebook-logo.png": 408,
	"./community/faria-logo": 409,
	"./community/faria-logo-horizontal-rounded": 410,
	"./community/faria-logo-horizontal-rounded.png": 410,
	"./community/faria-logo.png": 409,
	"./community/fb-logo": 353,
	"./community/fb-logo.png": 353,
	"./community/filter-logo": 358,
	"./community/filter-logo.png": 358,
	"./community/global": 296,
	"./community/global.png": 296,
	"./community/info-logo": 411,
	"./community/info-logo.png": 411,
	"./community/link-icon": 354,
	"./community/link-icon.png": 354,
	"./community/linkedin-logo": 355,
	"./community/linkedin-logo.png": 355,
	"./community/logo-admissions": 412,
	"./community/logo-admissions.png": 412,
	"./community/logo-atlas": 413,
	"./community/logo-atlas.png": 413,
	"./community/logo-mb": 414,
	"./community/logo-mb.png": 414,
	"./community/logo-online-courses": 415,
	"./community/logo-online-courses.png": 415,
	"./community/logo-osc": 416,
	"./community/logo-osc.png": 416,
	"./community/logo-pd": 417,
	"./community/logo-pd.png": 417,
	"./community/mb-badge": 418,
	"./community/mb-badge-static": 419,
	"./community/mb-badge-static.png": 419,
	"./community/mb-badge.png": 418,
	"./community/mobile-bar": 420,
	"./community/mobile-bar.png": 420,
	"./community/resource-1": 421,
	"./community/resource-1.png": 421,
	"./community/resource-2": 422,
	"./community/resource-2.png": 422,
	"./community/ryan": 423,
	"./community/ryan.jpeg": 423,
	"./community/school-logo": 424,
	"./community/school-logo.png": 424,
	"./community/screencapture-localhost-3000-community-index-show-2022-12-21-12_23_58": 425,
	"./community/screencapture-localhost-3000-community-index-show-2022-12-21-12_23_58.png": 425,
	"./community/twitter-logo": 356,
	"./community/twitter-logo-transparent": 426,
	"./community/twitter-logo-transparent.png": 426,
	"./community/twitter-logo.png": 356,
	"./community/x-mark": 427,
	"./community/x-mark-blue": 428,
	"./community/x-mark-blue.png": 428,
	"./community/x-mark.png": 427,
	"./community_index/alpha-sort-icon": 1187,
	"./community_index/alpha-sort-icon.png": 1187,
	"./community_index/asc-sort-icon": 1188,
	"./community_index/asc-sort-icon.png": 1188,
	"./community_index/chevron_right": 1189,
	"./community_index/chevron_right.svg": 1189,
	"./community_index/close-button": 309,
	"./community_index/close-button.png": 309,
	"./community_index/close-icon": 1404,
	"./community_index/close-icon.png": 1404,
	"./community_index/collapse-icon": 1405,
	"./community_index/collapse-icon.svg": 1405,
	"./community_index/community-hands": 1235,
	"./community_index/community-hands.png": 1235,
	"./community_index/community-pattern": 1406,
	"./community_index/community-pattern.png": 1406,
	"./community_index/expand-icon": 1407,
	"./community_index/expand-icon.svg": 1407,
	"./community_index/grid-view-icon": 1190,
	"./community_index/grid-view-icon.png": 1190,
	"./community_index/icon-arrow-right": 1408,
	"./community_index/icon-arrow-right.png": 1408,
	"./community_index/icon-info": 1236,
	"./community_index/icon-info.svg": 1236,
	"./community_index/mission_statement_author": 1237,
	"./community_index/mission_statement_author.png": 1237,
	"./community_index/open": 1409,
	"./community_index/open.svg": 1409,
	"./community_index/pattern": 1410,
	"./community_index/pattern.png": 1410,
	"./community_index/sort-icon": 1191,
	"./community_index/sort-icon.png": 1191,
	"./credit-card": 1238,
	"./credit-card.png": 1238,
	"./cross-with-circle-border": 1411,
	"./cross-with-circle-border.svg": 1411,
	"./currency-rates": 1399,
	"./currency-rates.png": 1399,
	"./dashed-line": 1412,
	"./dashed-line.png": 1412,
	"./default-logo": 586,
	"./default-logo.png": 586,
	"./doc": 1192,
	"./doc.svg": 1192,
	"./dropdown": 1413,
	"./dropdown.svg": 1413,
	"./dropdown2": 1414,
	"./dropdown2.png": 1414,
	"./expand-toggle-icon": 365,
	"./expand-toggle-icon.png": 365,
	"./faria_products/ADV-PLACEMENT": 1239,
	"./faria_products/ADV-PLACEMENT.png": 1239,
	"./faria_products/AN-AR": 1240,
	"./faria_products/AN-AR.png": 1240,
	"./faria_products/AN-BH": 1241,
	"./faria_products/AN-BH.png": 1241,
	"./faria_products/AN-CPN": 1242,
	"./faria_products/AN-CPN.png": 1242,
	"./faria_products/AN-PBL": 1243,
	"./faria_products/AN-PBL.png": 1243,
	"./faria_products/AN-PF": 1244,
	"./faria_products/AN-PF.png": 1244,
	"./faria_products/AN-SL": 1245,
	"./faria_products/AN-SL.png": 1245,
	"./faria_products/AN-TL": 1246,
	"./faria_products/AN-TL.png": 1246,
	"./faria_products/AP-DP": 429,
	"./faria_products/AP-DP.png": 429,
	"./faria_products/AP-DP.svg": 1480,
	"./faria_products/APPLUS": 1247,
	"./faria_products/APPLUS.png": 1247,
	"./faria_products/APSTD": 1248,
	"./faria_products/APSTD.png": 1248,
	"./faria_products/ATLAS_STUDENT": 1249,
	"./faria_products/ATLAS_STUDENT.png": 1249,
	"./faria_products/Add-Ons & Partners": 1250,
	"./faria_products/Add-Ons & Partners.png": 1250,
	"./faria_products/Advanced Placement": 1415,
	"./faria_products/Advanced Placement.svg": 1415,
	"./faria_products/AssessPrep": 1251,
	"./faria_products/AssessPrep.png": 1251,
	"./faria_products/Atlas": 1252,
	"./faria_products/Atlas.png": 1252,
	"./faria_products/AtlasNext": 1253,
	"./faria_products/AtlasNext.png": 1253,
	"./faria_products/AtlasNext_logo": 594,
	"./faria_products/AtlasNext_logo.png": 594,
	"./faria_products/Attendance": 1254,
	"./faria_products/Attendance.png": 1254,
	"./faria_products/BRIDGEU": 1255,
	"./faria_products/BRIDGEU.png": 1255,
	"./faria_products/Behavior & Discipline": 1416,
	"./faria_products/Behavior & Discipline.svg": 1416,
	"./faria_products/C1 Advanced Placement": 1256,
	"./faria_products/C1 Advanced Placement.png": 1256,
	"./faria_products/CAM-ADV": 430,
	"./faria_products/CAM-ADV.png": 430,
	"./faria_products/CAM-ADV.svg": 1481,
	"./faria_products/CAM-IGCSE": 1257,
	"./faria_products/CAM-IGCSE.png": 1257,
	"./faria_products/CAM-LS": 431,
	"./faria_products/CAM-LS.png": 431,
	"./faria_products/CAM-LS.svg": 1482,
	"./faria_products/CONNECT": 1258,
	"./faria_products/CONNECT.png": 1258,
	"./faria_products/CP": 1259,
	"./faria_products/CP.png": 1259,
	"./faria_products/CT-AR": 1260,
	"./faria_products/CT-AR.png": 1260,
	"./faria_products/CT-CPN": 1261,
	"./faria_products/CT-CPN.png": 1261,
	"./faria_products/CT-TL": 1262,
	"./faria_products/CT-TL.png": 1262,
	"./faria_products/CTNext": 1263,
	"./faria_products/CTNext.png": 1263,
	"./faria_products/CUR-CH": 1264,
	"./faria_products/CUR-CH.png": 1264,
	"./faria_products/Cambridge IGCSE's": 432,
	"./faria_products/Cambridge IGCSE's.png": 432,
	"./faria_products/Cambridge IGCSE's.svg": 1483,
	"./faria_products/Curriculum First": 1265,
	"./faria_products/Curriculum First.png": 1265,
	"./faria_products/Curriculum Trak Next": 610,
	"./faria_products/Curriculum Trak Next.png": 610,
	"./faria_products/CurriculumTrak & CTNext": 1266,
	"./faria_products/CurriculumTrak & CTNext.png": 1266,
	"./faria_products/DPCORE": 1267,
	"./faria_products/DPCORE.png": 1267,
	"./faria_products/DPPRO": 1268,
	"./faria_products/DPPRO.png": 1268,
	"./faria_products/FARIA1": 1269,
	"./faria_products/FARIA1.png": 1269,
	"./faria_products/FARIA1PLUS": 1270,
	"./faria_products/FARIA1PLUS.png": 1270,
	"./faria_products/FARIA1STD": 1271,
	"./faria_products/FARIA1STD.png": 1271,
	"./faria_products/GDPR": 1417,
	"./faria_products/GDPR.svg": 1417,
	"./faria_products/HIGH": 1272,
	"./faria_products/HIGH.png": 1272,
	"./faria_products/IB Career Programme": 1273,
	"./faria_products/IB Career Programme.png": 1273,
	"./faria_products/IB Diploma Programme": 1274,
	"./faria_products/IB Diploma Programme.png": 1274,
	"./faria_products/IB Middle Years Programme": 1275,
	"./faria_products/IB Middle Years Programme.png": 1275,
	"./faria_products/IB Primary Years": 1276,
	"./faria_products/IB Primary Years.png": 1276,
	"./faria_products/IDAT": 1277,
	"./faria_products/IDAT.png": 1277,
	"./faria_products/IDATCONCISE": 1278,
	"./faria_products/IDATCONCISE.png": 1278,
	"./faria_products/Integrations": 1279,
	"./faria_products/Integrations.png": 1279,
	"./faria_products/KEYCHAT": 1280,
	"./faria_products/KEYCHAT.png": 1280,
	"./faria_products/MB_CHAT": 1281,
	"./faria_products/MB_CHAT.png": 1281,
	"./faria_products/MB_MAX": 1282,
	"./faria_products/MB_MAX.png": 1282,
	"./faria_products/MB_MAX_logo": 595,
	"./faria_products/MB_MAX_logo.png": 595,
	"./faria_products/MB_PASSPORT": 1283,
	"./faria_products/MB_PASSPORT.png": 1283,
	"./faria_products/MB_PASSPORT_logo": 614,
	"./faria_products/MB_PASSPORT_logo.png": 614,
	"./faria_products/MB_PRO": 1284,
	"./faria_products/MB_PRO.png": 1284,
	"./faria_products/MB_PRO_logo": 596,
	"./faria_products/MB_PRO_logo.png": 596,
	"./faria_products/MIDDLE": 1285,
	"./faria_products/MIDDLE.png": 1285,
	"./faria_products/MPD_ALL": 1286,
	"./faria_products/MPD_ALL.png": 1286,
	"./faria_products/MPD_MYP": 1287,
	"./faria_products/MPD_MYP.png": 1287,
	"./faria_products/MPD_PYP": 1288,
	"./faria_products/MPD_PYP.png": 1288,
	"./faria_products/MYP": 1289,
	"./faria_products/MYP.png": 1289,
	"./faria_products/ManageBac": 1290,
	"./faria_products/ManageBac.png": 1290,
	"./faria_products/ManageBacLogo": 611,
	"./faria_products/ManageBacLogo.png": 611,
	"./faria_products/OA": 612,
	"./faria_products/OA.png": 612,
	"./faria_products/OASD": 1291,
	"./faria_products/OASD.png": 1291,
	"./faria_products/OA_CRM": 1292,
	"./faria_products/OA_CRM.png": 1292,
	"./faria_products/OSC": 1293,
	"./faria_products/OSC Study App": 1294,
	"./faria_products/OSC Study App.png": 1294,
	"./faria_products/OSC.png": 1293,
	"./faria_products/OSCAPP": 1295,
	"./faria_products/OSCAPP.png": 1295,
	"./faria_products/OpenApply": 1296,
	"./faria_products/OpenApply.png": 1296,
	"./faria_products/PEA-ADV": 433,
	"./faria_products/PEA-ADV.png": 433,
	"./faria_products/PEA-ADV.svg": 1484,
	"./faria_products/PEA-EDE": 434,
	"./faria_products/PEA-EDE.png": 434,
	"./faria_products/PEA-EDE.svg": 1485,
	"./faria_products/PEA-IGCSE": 435,
	"./faria_products/PEA-IGCSE.png": 435,
	"./faria_products/PEA-IGCSE.svg": 1486,
	"./faria_products/PMJ_ALEVELS": 1297,
	"./faria_products/PMJ_ALEVELS.png": 1297,
	"./faria_products/PMJ_IB": 1298,
	"./faria_products/PMJ_IB.png": 1298,
	"./faria_products/PMJ_IGCSE": 1299,
	"./faria_products/PMJ_IGCSE.png": 1299,
	"./faria_products/POC-A-Level": 1300,
	"./faria_products/POC-A-Level.png": 1300,
	"./faria_products/POC-IB": 1301,
	"./faria_products/POC-IB.png": 1301,
	"./faria_products/POC-IGCSE": 1302,
	"./faria_products/POC-IGCSE.png": 1302,
	"./faria_products/POWERSCHOOL": 1303,
	"./faria_products/POWERSCHOOL.png": 1303,
	"./faria_products/PREMIUM_SUPPORT": 1304,
	"./faria_products/PREMIUM_SUPPORT.png": 1304,
	"./faria_products/PRIMARY": 1305,
	"./faria_products/PRIMARY.png": 1305,
	"./faria_products/PYP": 1306,
	"./faria_products/PYP.png": 1306,
	"./faria_products/Pamoja": 367,
	"./faria_products/Pamoja Online Courses - Cambridge IGCSE": 1307,
	"./faria_products/Pamoja Online Courses - Cambridge IGCSE.png": 1307,
	"./faria_products/Pamoja Online Courses - Cambridge International A-Level": 1308,
	"./faria_products/Pamoja Online Courses - Cambridge International A-Level.png": 1308,
	"./faria_products/Pamoja Online Courses - IB": 1309,
	"./faria_products/Pamoja Online Courses - IB.png": 1309,
	"./faria_products/Pamoja.png": 367,
	"./faria_products/Pamoja.svg": 1487,
	"./faria_products/Partner Add Ons": 1310,
	"./faria_products/Partner Add Ons.png": 1310,
	"./faria_products/Reports": 660,
	"./faria_products/Reports.png": 660,
	"./faria_products/SB-LF-ACTIVITIES-001": 1311,
	"./faria_products/SB-LF-ACTIVITIES-001.png": 1311,
	"./faria_products/SB-LF-ACTIVITIES-002": 1312,
	"./faria_products/SB-LF-ACTIVITIES-002.png": 1312,
	"./faria_products/SB-LF-COMMUNICATIONS-001": 1313,
	"./faria_products/SB-LF-COMMUNICATIONS-001.png": 1313,
	"./faria_products/SB-LF-CORE-001": 1314,
	"./faria_products/SB-LF-CORE-001.png": 1314,
	"./faria_products/SB-LF-ONLINEPAYMENTS-001": 1315,
	"./faria_products/SB-LF-ONLINEPAYMENTS-001.png": 1315,
	"./faria_products/SB-LF-ONLINEPAYMENTS-002": 1316,
	"./faria_products/SB-LF-ONLINEPAYMENTS-002.png": 1316,
	"./faria_products/SB-LF-PARENTMEETINGS-001": 1317,
	"./faria_products/SB-LF-PARENTMEETINGS-001.png": 1317,
	"./faria_products/SB-LF-Transport-002": 1318,
	"./faria_products/SB-LF-Transport-002.png": 1318,
	"./faria_products/SIMSEPORT": 1319,
	"./faria_products/SIMSEPORT.png": 1319,
	"./faria_products/SMARTPREP": 1320,
	"./faria_products/SMARTPREP.png": 1320,
	"./faria_products/SPECIALREPORT": 1321,
	"./faria_products/SPECIALREPORT.png": 1321,
	"./faria_products/SSO Google": 1322,
	"./faria_products/SSO Google.png": 1322,
	"./faria_products/SSO office 365": 1323,
	"./faria_products/SSO office 365.png": 1323,
	"./faria_products/STN_MAINTENANCE": 1324,
	"./faria_products/STN_MAINTENANCE.png": 1324,
	"./faria_products/SchoolsBuddy": 613,
	"./faria_products/SchoolsBuddy.png": 613,
	"./faria_products/add_icon": 1418,
	"./faria_products/add_icon.svg": 1418,
	"./faria_products/check_icon": 1193,
	"./faria_products/check_icon.svg": 1193,
	"./faria_products/info_icon": 1419,
	"./faria_products/info_icon.svg": 1419,
	"./file": 1194,
	"./file.svg": 1194,
	"./file_extension_pdf": 587,
	"./file_extension_pdf.png": 587,
	"./gray-cross": 582,
	"./gray-cross.svg": 582,
	"./header_bar_arrow": 1391,
	"./header_bar_arrow.png": 1391,
	"./icon-pdf": 1400,
	"./icon-pdf.png": 1400,
	"./icon-pen": 1392,
	"./icon-pen.png": 1392,
	"./icon-sorting": 366,
	"./icon-sorting.png": 366,
	"./icon_calendar_blue_outline": 1195,
	"./icon_calendar_blue_outline.svg": 1195,
	"./icon_email": 1420,
	"./icon_email.svg": 1420,
	"./icon_email_blue_outline": 1196,
	"./icon_email_blue_outline.svg": 1196,
	"./icon_export": 1197,
	"./icon_export.svg": 1197,
	"./icon_file": 1421,
	"./icon_file.svg": 1421,
	"./icon_help": 1422,
	"./icon_help.svg": 1422,
	"./icon_message": 1198,
	"./icon_message.svg": 1198,
	"./icon_portfolio": 1199,
	"./icon_portfolio.svg": 1199,
	"./image": 588,
	"./image.svg": 588,
	"./information": 583,
	"./information.png": 583,
	"./information.svg": 1488,
	"./information2": 656,
	"./information2.svg": 656,
	"./link": 1200,
	"./link.svg": 1200,
	"./pdf": 584,
	"./pdf.svg": 584,
	"./phone": 1423,
	"./phone.svg": 1423,
	"./productsDetail.json": 1489,
	"./services_manager/app-store": 597,
	"./services_manager/app-store.svg": 597,
	"./services_manager/arrow-down": 332,
	"./services_manager/arrow-down.svg": 332,
	"./services_manager/arrow-up": 357,
	"./services_manager/arrow-up.svg": 357,
	"./services_manager/background": 598,
	"./services_manager/background.png": 598,
	"./services_manager/bank_transfer": 599,
	"./services_manager/bank_transfer.png": 599,
	"./services_manager/banners/AN - Curriculum Coaching": 661,
	"./services_manager/banners/AN - Curriculum Coaching.png": 661,
	"./services_manager/banners/AN - Teaching & Learning": 662,
	"./services_manager/banners/AN - Teaching & Learning.png": 662,
	"./services_manager/banners/AO - 8,000 flashcards, 3,000 video tutorials and 24 revision guides all in one app": 663,
	"./services_manager/banners/AO - 8,000 flashcards, 3,000 video tutorials and 24 revision guides all in one app.png": 663,
	"./services_manager/banners/AO - By Blending different media": 664,
	"./services_manager/banners/AO - By Blending different media.png": 664,
	"./services_manager/banners/AO - Centralise Whole School Communication": 665,
	"./services_manager/banners/AO - Centralise Whole School Communication.png": 665,
	"./services_manager/banners/AO - Flexible Homeroom": 666,
	"./services_manager/banners/AO - Flexible Homeroom.png": 666,
	"./services_manager/banners/AO - Improve collaboration for remote learning": 667,
	"./services_manager/banners/AO - Improve collaboration for remote learning.png": 667,
	"./services_manager/banners/AO - OSC Pre-built customisable reporting templates": 668,
	"./services_manager/banners/AO - OSC Pre-built customisable reporting templates.png": 668,
	"./services_manager/banners/AO - Powerful Attendance Management": 669,
	"./services_manager/banners/AO - Powerful Attendance Management.png": 669,
	"./services_manager/banners/AO - Pre-built customisable reporting templates": 670,
	"./services_manager/banners/AO - Pre-built customisable reporting templates.png": 670,
	"./services_manager/banners/AO - Schrole Connect": 671,
	"./services_manager/banners/AO - Schrole Connect.png": 671,
	"./services_manager/banners/AO - Streamline School to home reporting": 672,
	"./services_manager/banners/AO - Streamline School to home reporting.png": 672,
	"./services_manager/banners/Asses Prep - Go Paperless with AssessPrep for Online Exams_ with Powerful eAssessment": 673,
	"./services_manager/banners/Asses Prep - Go Paperless with AssessPrep for Online Exams_ with Powerful eAssessment.png": 673,
	"./services_manager/banners/AssesPrep - Collaboratively Create Assessments_with Videos, Simulations, Images and_a Variety of Question Types": 674,
	"./services_manager/banners/AssesPrep - Collaboratively Create Assessments_with Videos, Simulations, Images and_a Variety of Question Types.png": 674,
	"./services_manager/banners/Atlas - Initiate, revamp and continuously": 675,
	"./services_manager/banners/Atlas - Initiate, revamp and continuously.png": 675,
	"./services_manager/banners/Atlas - Seamless and integrated": 676,
	"./services_manager/banners/Atlas - Seamless and integrated.png": 676,
	"./services_manager/banners/Atlas - access to dedicated support team": 677,
	"./services_manager/banners/Atlas - access to dedicated support team.png": 677,
	"./services_manager/banners/Atlas - customized report on curriculum": 678,
	"./services_manager/banners/Atlas - customized report on curriculum.png": 678,
	"./services_manager/banners/BRIDGEU": 679,
	"./services_manager/banners/BRIDGEU.png": 679,
	"./services_manager/banners/CTNext - Copy of Powering Curriculum for Faith-Based Schools": 680,
	"./services_manager/banners/CTNext - Copy of Powering Curriculum for Faith-Based Schools.png": 680,
	"./services_manager/banners/CTNext - Planning ManagementPowering Curriculum for Faith-Based Schools": 681,
	"./services_manager/banners/CTNext - Planning ManagementPowering Curriculum for Faith-Based Schools.png": 681,
	"./services_manager/banners/CTNext - Powering Curriculum for Faith-Based Schools": 682,
	"./services_manager/banners/CTNext - Powering Curriculum for Faith-Based Schools.png": 682,
	"./services_manager/banners/FOE - All in One Systems": 683,
	"./services_manager/banners/FOE - All in One Systems.png": 683,
	"./services_manager/banners/FOP - All in One Systems": 684,
	"./services_manager/banners/FOP - All in One Systems.png": 684,
	"./services_manager/banners/FOS - All in One Systems": 685,
	"./services_manager/banners/FOS - All in One Systems.png": 685,
	"./services_manager/banners/IDATCONCISE": 686,
	"./services_manager/banners/IDATCONCISE.png": 686,
	"./services_manager/banners/IM_FariaOne_Banner": 600,
	"./services_manager/banners/IM_FariaOne_Banner.png": 600,
	"./services_manager/banners/MB AP - Advanced Placement": 687,
	"./services_manager/banners/MB AP - Advanced Placement.png": 687,
	"./services_manager/banners/MB AP - Copy of Build Stunning Student Portfolios": 688,
	"./services_manager/banners/MB AP - Copy of Build Stunning Student Portfolios.png": 688,
	"./services_manager/banners/MB AP - Copy of Collaborative Planning, Assessment & Reporting": 689,
	"./services_manager/banners/MB AP - Copy of Collaborative Planning, Assessment & Reporting.png": 689,
	"./services_manager/banners/MB AP - Copy of Integrated Remote Learning": 690,
	"./services_manager/banners/MB AP - Copy of Integrated Remote Learning.png": 690,
	"./services_manager/banners/MB AP - Copy of Manage Service Learning and Project-based Learning": 691,
	"./services_manager/banners/MB AP - Copy of Manage Service Learning and Project-based Learning.png": 691,
	"./services_manager/banners/MB AP - Copy of Streamline School-to-Home Reporting": 692,
	"./services_manager/banners/MB AP - Copy of Streamline School-to-Home Reporting.png": 692,
	"./services_manager/banners/MB CAM - All-in-One Learning Platform for Cambridge International Schools": 693,
	"./services_manager/banners/MB CAM - All-in-One Learning Platform for Cambridge International Schools.png": 693,
	"./services_manager/banners/MB CHAT - DIrect Messaging": 694,
	"./services_manager/banners/MB CHAT - DIrect Messaging.png": 694,
	"./services_manager/banners/MB CP - Bring your IB CP Core Online": 695,
	"./services_manager/banners/MB CP - Bring your IB CP Core Online.png": 695,
	"./services_manager/banners/MB CP - Build Stunning Student Portfolios": 696,
	"./services_manager/banners/MB CP - Build Stunning Student Portfolios.png": 696,
	"./services_manager/banners/MB CP - For IB DP Students on the Go": 697,
	"./services_manager/banners/MB CP - For IB DP Students on the Go.png": 697,
	"./services_manager/banners/MB CP - Manage Service Learning, Reflective Project _& Language Portfolios": 698,
	"./services_manager/banners/MB CP - Manage Service Learning, Reflective Project _& Language Portfolios.png": 698,
	"./services_manager/banners/MB CP - Stay up-to-date with IB CP and the new PS&P": 699,
	"./services_manager/banners/MB CP - Stay up-to-date with IB CP and the new PS&P.png": 699,
	"./services_manager/banners/MB DPCORE - Bring your IB Diploma Core Online": 700,
	"./services_manager/banners/MB DPCORE - Bring your IB Diploma Core Online.png": 700,
	"./services_manager/banners/MB DPCORE - Build Student Portfolios": 701,
	"./services_manager/banners/MB DPCORE - Build Student Portfolios.png": 701,
	"./services_manager/banners/MB DPCORE - Centralise your ib deadline": 702,
	"./services_manager/banners/MB DPCORE - Centralise your ib deadline.png": 702,
	"./services_manager/banners/MB DPCORE - For IB DP Students on the": 703,
	"./services_manager/banners/MB DPCORE - For IB DP Students on the.png": 703,
	"./services_manager/banners/MB DPCORE - Streamline Exam Registration": 704,
	"./services_manager/banners/MB DPCORE - Streamline Exam Registration.png": 704,
	"./services_manager/banners/MB DPPRO - Automatic Curriculum Updates for the DP_and the new PS&P": 705,
	"./services_manager/banners/MB DPPRO - Automatic Curriculum Updates for the DP_and the new PS&P.png": 705,
	"./services_manager/banners/MB DPPRO - Bring your IB Diploma Core Online": 706,
	"./services_manager/banners/MB DPPRO - Bring your IB Diploma Core Online.png": 706,
	"./services_manager/banners/MB DPPRO - Build Student Portfolios": 707,
	"./services_manager/banners/MB DPPRO - Build Student Portfolios.png": 707,
	"./services_manager/banners/MB DPPRO - For IB DP Students on the": 708,
	"./services_manager/banners/MB DPPRO - For IB DP Students on the.png": 708,
	"./services_manager/banners/MB DPPRO - Manage the IB DP & Internal Assessment with_seamless IB eCoursework Integration": 709,
	"./services_manager/banners/MB DPPRO - Manage the IB DP & Internal Assessment with_seamless IB eCoursework Integration.png": 709,
	"./services_manager/banners/MB DPPRO - Streamline Exam Registration copy": 710,
	"./services_manager/banners/MB DPPRO - Streamline Exam Registration copy.png": 710,
	"./services_manager/banners/MB MYP - Bring your IB MYP": 711,
	"./services_manager/banners/MB MYP - Bring your IB MYP.png": 711,
	"./services_manager/banners/MB MYP - Build Stunning Student Portfolios": 712,
	"./services_manager/banners/MB MYP - Build Stunning Student Portfolios.png": 712,
	"./services_manager/banners/MB MYP - Collaborative Planning, Assessment": 713,
	"./services_manager/banners/MB MYP - Collaborative Planning, Assessment.png": 713,
	"./services_manager/banners/MB MYP - Manage SA-PP-CP": 714,
	"./services_manager/banners/MB MYP - Manage SA-PP-CP.png": 714,
	"./services_manager/banners/MB MYP - Stay up to date with MYP": 715,
	"./services_manager/banners/MB MYP - Stay up to date with MYP.png": 715,
	"./services_manager/banners/MB NC - Copy of Build Stunning Student Portfolios": 716,
	"./services_manager/banners/MB NC - Copy of Build Stunning Student Portfolios.png": 716,
	"./services_manager/banners/MB NC - Copy of Collaborative Planning, Assessment & Reporting": 717,
	"./services_manager/banners/MB NC - Copy of Collaborative Planning, Assessment & Reporting.png": 717,
	"./services_manager/banners/MB NC - Copy of Integrated Remote Learning": 718,
	"./services_manager/banners/MB NC - Copy of Integrated Remote Learning.png": 718,
	"./services_manager/banners/MB NC - Copy of Manage Service Learning and Project-based Learning": 719,
	"./services_manager/banners/MB NC - Copy of Manage Service Learning and Project-based Learning.png": 719,
	"./services_manager/banners/MB NC - Copy of Streamline School-to-Home Reporting": 720,
	"./services_manager/banners/MB NC - Copy of Streamline School-to-Home Reporting.png": 720,
	"./services_manager/banners/MB NC - National Curriculum - High School": 721,
	"./services_manager/banners/MB NC - National Curriculum - High School.png": 721,
	"./services_manager/banners/MB NC - National Curriculum - Middle School": 722,
	"./services_manager/banners/MB NC - National Curriculum - Middle School.png": 722,
	"./services_manager/banners/MB NC - National Curriculum - Primary School": 723,
	"./services_manager/banners/MB NC - National Curriculum - Primary School.png": 723,
	"./services_manager/banners/MB PYP - Build Stunning Student Portfolios": 724,
	"./services_manager/banners/MB PYP - Build Stunning Student Portfolios.png": 724,
	"./services_manager/banners/MB PYP - Collaborative Planning to build your_Programme of Inquiry": 725,
	"./services_manager/banners/MB PYP - Collaborative Planning to build your_Programme of Inquiry.png": 725,
	"./services_manager/banners/MB PYP - Redesigned for the _Enhanced Primary Years Programme": 726,
	"./services_manager/banners/MB PYP - Redesigned for the _Enhanced Primary Years Programme.png": 726,
	"./services_manager/banners/MB PYP - Streamline Exam Registration": 727,
	"./services_manager/banners/MB PYP - Streamline Exam Registration.png": 727,
	"./services_manager/banners/MB UKAC - All-in-One Learning Platform for PE International Schools": 728,
	"./services_manager/banners/MB UKAC - All-in-One Learning Platform for PE International Schools.png": 728,
	"./services_manager/banners/MB UKAC - Build Stunning Student Portfolios": 729,
	"./services_manager/banners/MB UKAC - Build Stunning Student Portfolios.png": 729,
	"./services_manager/banners/MB UKAC - Collaborative Planning, Assessment & Reporting": 730,
	"./services_manager/banners/MB UKAC - Collaborative Planning, Assessment & Reporting.png": 730,
	"./services_manager/banners/MB UKAC - Integrated Remote Learning": 731,
	"./services_manager/banners/MB UKAC - Integrated Remote Learning.png": 731,
	"./services_manager/banners/MB UKAC - Manage Service Learning and Project-based Learning": 732,
	"./services_manager/banners/MB UKAC - Manage Service Learning and Project-based Learning.png": 732,
	"./services_manager/banners/MB UKAC - Streamline School-to-Home Reporting": 733,
	"./services_manager/banners/MB UKAC - Streamline School-to-Home Reporting.png": 733,
	"./services_manager/banners/MB_MAX": 734,
	"./services_manager/banners/MB_MAX.png": 734,
	"./services_manager/banners/MB_PASSPORT": 735,
	"./services_manager/banners/MB_PASSPORT.png": 735,
	"./services_manager/banners/MB_PRO": 736,
	"./services_manager/banners/MB_PRO.png": 736,
	"./services_manager/banners/MPD_ALL_1": 737,
	"./services_manager/banners/MPD_ALL_1.png": 737,
	"./services_manager/banners/MPD_MYP_1": 738,
	"./services_manager/banners/MPD_MYP_1.png": 738,
	"./services_manager/banners/MPD_PYP_1": 739,
	"./services_manager/banners/MPD_PYP_1.png": 739,
	"./services_manager/banners/OA - Attract, nurture and convert prospective studentsto yourschool with the new OpenApply CRM": 740,
	"./services_manager/banners/OA - Attract, nurture and convert prospective studentsto yourschool with the new OpenApply CRM.png": 740,
	"./services_manager/banners/OA - Automatically subscribe parents to mailing lists_when they meet specific customisable criteria": 741,
	"./services_manager/banners/OA - Automatically subscribe parents to mailing lists_when they meet specific customisable criteria.png": 741,
	"./services_manager/banners/OA - Capture and nurture pre-enquiry prospects directly _on OpenApply by sending automated scheduled emails,_and tracking sources": 742,
	"./services_manager/banners/OA - Capture and nurture pre-enquiry prospects directly _on OpenApply by sending automated scheduled emails,_and tracking sources.png": 742,
	"./services_manager/banners/OA - Centralise all applicant information online with_interviews, payments & exam history": 743,
	"./services_manager/banners/OA - Centralise all applicant information online with_interviews, payments & exam history.png": 743,
	"./services_manager/banners/OA - End-to-end online applicant review": 744,
	"./services_manager/banners/OA - End-to-end online applicant review.png": 744,
	"./services_manager/banners/OA - Monitor which sources are successful, like Facebook,_emails campaigns, WeChat, Google Ads, etc": 745,
	"./services_manager/banners/OA - Monitor which sources are successful, like Facebook,_emails campaigns, WeChat, Google Ads, etc.png": 745,
	"./services_manager/banners/OA - Our export tool helps you easily transfer_your data into SIMS": 746,
	"./services_manager/banners/OA - Our export tool helps you easily transfer_your data into SIMS.png": 746,
	"./services_manager/banners/OA - Pin down defining data characteristics to show_your school leadership team and help guide your_department in the right direction": 747,
	"./services_manager/banners/OA - Pin down defining data characteristics to show_your school leadership team and help guide your_department in the right direction.png": 747,
	"./services_manager/banners/OA - Powerschool": 748,
	"./services_manager/banners/OA - Powerschool.png": 748,
	"./services_manager/banners/OA - Robust filtering, searching, and tagging_ helps you manage student information": 749,
	"./services_manager/banners/OA - Robust filtering, searching, and tagging_ helps you manage student information.png": 749,
	"./services_manager/banners/OA - Set up automatic notifications when a specified activity_is triggered. Ensure that no applicant is missed": 750,
	"./services_manager/banners/OA - Set up automatic notifications when a specified activity_is triggered. Ensure that no applicant is missed.png": 750,
	"./services_manager/banners/OA - Simplifying the admissions process": 751,
	"./services_manager/banners/OA - Simplifying the admissions process.png": 751,
	"./services_manager/banners/OA - The International Diagnostic and Admissions Test (IDAT) is a revolutionary global test for students of all ages from around the world": 752,
	"./services_manager/banners/OA - The International Diagnostic and Admissions Test (IDAT) is a revolutionary global test for students of all ages from around the world.png": 752,
	"./services_manager/banners/OA - The Schools Directory links thousands of international schools around the world": 753,
	"./services_manager/banners/OA - The Schools Directory links thousands of international schools around the world.png": 753,
	"./services_manager/banners/OSC - 24 revision guides aligned to the latest IB curricula and written by IB reports": 754,
	"./services_manager/banners/OSC - 24 revision guides aligned to the latest IB curricula and written by IB reports.png": 754,
	"./services_manager/banners/OSC - Perfect companion for mockup and final exams": 755,
	"./services_manager/banners/OSC - Perfect companion for mockup and final exams.png": 755,
	"./services_manager/banners/Pamoja - Lesson Suite - IB": 756,
	"./services_manager/banners/Pamoja - Lesson Suite - IB.png": 756,
	"./services_manager/banners/Pamoja - Lesson Suite - IB_2": 757,
	"./services_manager/banners/Pamoja - Lesson Suite - IB_2.png": 757,
	"./services_manager/banners/Pamoja - Our Online courses cover the same course": 758,
	"./services_manager/banners/Pamoja - Our Online courses cover the same course.png": 758,
	"./services_manager/banners/Pamoja - POC taugh by experienced IB Teachers": 759,
	"./services_manager/banners/Pamoja - POC taugh by experienced IB Teachers.png": 759,
	"./services_manager/banners/Pamoja Lesson Suite - Cambridge IGCSE": 760,
	"./services_manager/banners/Pamoja Lesson Suite - Cambridge IGCSE.png": 760,
	"./services_manager/banners/Pamoja Lesson Suite - Cambridge IGCSE_2": 761,
	"./services_manager/banners/Pamoja Lesson Suite - Cambridge IGCSE_2.png": 761,
	"./services_manager/banners/Pamoja Lesson Suite - Cambridge International": 762,
	"./services_manager/banners/Pamoja Lesson Suite - Cambridge International.png": 762,
	"./services_manager/banners/SB - Send communication to the whole school": 763,
	"./services_manager/banners/SB - Send communication to the whole school.png": 763,
	"./services_manager/banners/SB - Tuition Fee Management - Coming Soon": 764,
	"./services_manager/banners/SB - Tuition Fee Management - Coming Soon.png": 764,
	"./services_manager/banners/SB - auto update to reflect student activities": 765,
	"./services_manager/banners/SB - auto update to reflect student activities.png": 765,
	"./services_manager/banners/SB - bill collect and track parent payment": 766,
	"./services_manager/banners/SB - bill collect and track parent payment.png": 766,
	"./services_manager/banners/SB - fast allocation of activities": 767,
	"./services_manager/banners/SB - fast allocation of activities.png": 767,
	"./services_manager/banners/SB - full reporting dashboard": 768,
	"./services_manager/banners/SB - full reporting dashboard.png": 768,
	"./services_manager/banners/SB - organise track and monitor complex transport list": 769,
	"./services_manager/banners/SB - organise track and monitor complex transport list.png": 769,
	"./services_manager/banners/SB - save money paper and time": 770,
	"./services_manager/banners/SB - save money paper and time.png": 770,
	"./services_manager/banners/SB - take micropayment for all kind of school life transaction": 771,
	"./services_manager/banners/SB - take micropayment for all kind of school life transaction.png": 771,
	"./services_manager/banners/SB Bookings - A booking system for handling care sessions,_breakfast clubs, music lessons and more": 772,
	"./services_manager/banners/SB Bookings - A booking system for handling care sessions,_breakfast clubs, music lessons and more.png": 772,
	"./services_manager/banners/SB Bookings - With SchoolsBuddy's micropayments module_you can also charge fees": 773,
	"./services_manager/banners/SB Bookings - With SchoolsBuddy's micropayments module_you can also charge fees.png": 773,
	"./services_manager/banners/SB Conference - Integrated with your MIS": 774,
	"./services_manager/banners/SB Conference - Integrated with your MIS.png": 774,
	"./services_manager/banners/SB Conference - Schoolsbuddy is available on web and mobile": 775,
	"./services_manager/banners/SB Conference - Schoolsbuddy is available on web and mobile.png": 775,
	"./services_manager/banners/SB Conference - Support remote appointment": 776,
	"./services_manager/banners/SB Conference - Support remote appointment.png": 776,
	"./services_manager/banners/SB Core - End to end management": 777,
	"./services_manager/banners/SB Core - End to end management.png": 777,
	"./services_manager/banners/SB Core - Organise groups student": 778,
	"./services_manager/banners/SB Core - Organise groups student.png": 778,
	"./services_manager/banners/SB Core - Your first step towards the perfect School-to-Home system": 779,
	"./services_manager/banners/SB Core - Your first step towards the perfect School-to-Home system.png": 779,
	"./services_manager/circled-plus": 601,
	"./services_manager/circled-plus.svg": 601,
	"./services_manager/credit_card": 368,
	"./services_manager/credit_card.png": 368,
	"./services_manager/description_icons/Admissions": 780,
	"./services_manager/description_icons/Admissions.png": 780,
	"./services_manager/description_icons/Assessment": 781,
	"./services_manager/description_icons/Assessment.png": 781,
	"./services_manager/description_icons/Attendance": 782,
	"./services_manager/description_icons/Attendance.png": 782,
	"./services_manager/description_icons/Bridgeu_Key_Features": 783,
	"./services_manager/description_icons/Bridgeu_Key_Features.png": 783,
	"./services_manager/description_icons/British International A Level": 784,
	"./services_manager/description_icons/British International A Level.png": 784,
	"./services_manager/description_icons/C1": 785,
	"./services_manager/description_icons/C1.png": 785,
	"./services_manager/description_icons/Cambridge": 786,
	"./services_manager/description_icons/Cambridge.png": 786,
	"./services_manager/description_icons/Collaborative Conversations": 787,
	"./services_manager/description_icons/Collaborative Conversations.png": 787,
	"./services_manager/description_icons/Collect Document and Payment": 788,
	"./services_manager/description_icons/Collect Document and Payment.png": 788,
	"./services_manager/description_icons/Communicators": 789,
	"./services_manager/description_icons/Communicators.png": 789,
	"./services_manager/description_icons/Curriculum": 790,
	"./services_manager/description_icons/Curriculum Coaching": 791,
	"./services_manager/description_icons/Curriculum Coaching.png": 791,
	"./services_manager/description_icons/Curriculum.png": 790,
	"./services_manager/description_icons/Enroll & Re-Enroll": 792,
	"./services_manager/description_icons/Enroll & Re-Enroll.png": 792,
	"./services_manager/description_icons/IB": 793,
	"./services_manager/description_icons/IB.png": 793,
	"./services_manager/description_icons/Integrations": 794,
	"./services_manager/description_icons/Integrations.png": 794,
	"./services_manager/description_icons/Interdisciplinary Assessment": 795,
	"./services_manager/description_icons/Interdisciplinary Assessment.png": 795,
	"./services_manager/description_icons/Learning and Teaching": 796,
	"./services_manager/description_icons/Learning and Teaching.png": 796,
	"./services_manager/description_icons/ManageBac Max": 797,
	"./services_manager/description_icons/ManageBac Max.png": 797,
	"./services_manager/description_icons/ManageBac Passport": 798,
	"./services_manager/description_icons/ManageBac Passport.png": 798,
	"./services_manager/description_icons/ManageBac Pro": 799,
	"./services_manager/description_icons/ManageBac Pro.png": 799,
	"./services_manager/description_icons/Online Course": 800,
	"./services_manager/description_icons/Online Course.png": 800,
	"./services_manager/description_icons/Premium Support": 801,
	"./services_manager/description_icons/Premium Support.png": 801,
	"./services_manager/description_icons/Primary School": 802,
	"./services_manager/description_icons/Primary School.png": 802,
	"./services_manager/description_icons/School": 803,
	"./services_manager/description_icons/School Leadership & Process": 804,
	"./services_manager/description_icons/School Leadership & Process.png": 804,
	"./services_manager/description_icons/School.png": 803,
	"./services_manager/description_icons/Service As Action": 805,
	"./services_manager/description_icons/Service As Action.png": 805,
	"./services_manager/description_icons/Special Reports": 806,
	"./services_manager/description_icons/Special Reports.png": 806,
	"./services_manager/description_icons/Student Portfolios": 615,
	"./services_manager/description_icons/Student Portfolios.png": 615,
	"./services_manager/description_icons/Subscription": 807,
	"./services_manager/description_icons/Subscription.png": 807,
	"./services_manager/description_icons/Technology": 808,
	"./services_manager/description_icons/Technology.png": 808,
	"./services_manager/description_icons/Track Leads Online": 809,
	"./services_manager/description_icons/Track Leads Online.png": 809,
	"./services_manager/description_icons/Virtual Cohorts": 810,
	"./services_manager/description_icons/Virtual Cohorts.png": 810,
	"./services_manager/detail_test1": 811,
	"./services_manager/detail_test1.png": 811,
	"./services_manager/detail_test2": 812,
	"./services_manager/detail_test2.png": 812,
	"./services_manager/faria-logo": 585,
	"./services_manager/faria-logo.png": 585,
	"./services_manager/faria-one-logo": 589,
	"./services_manager/faria-one-logo.png": 589,
	"./services_manager/flags/arabic": 813,
	"./services_manager/flags/arabic.png": 813,
	"./services_manager/flags/australia": 814,
	"./services_manager/flags/australia.png": 814,
	"./services_manager/flags/chinese": 815,
	"./services_manager/flags/chinese.png": 815,
	"./services_manager/flags/english": 602,
	"./services_manager/flags/english.png": 602,
	"./services_manager/flags/french": 816,
	"./services_manager/flags/french.png": 816,
	"./services_manager/flags/german": 817,
	"./services_manager/flags/german.png": 817,
	"./services_manager/flags/hong_kong": 818,
	"./services_manager/flags/hong_kong.png": 818,
	"./services_manager/flags/portuguese": 819,
	"./services_manager/flags/portuguese.png": 819,
	"./services_manager/flags/russian": 820,
	"./services_manager/flags/russian.png": 820,
	"./services_manager/flags/spanish": 821,
	"./services_manager/flags/spanish.png": 821,
	"./services_manager/flags/thai": 822,
	"./services_manager/flags/thai.png": 822,
	"./services_manager/flags/turkish": 823,
	"./services_manager/flags/turkish.png": 823,
	"./services_manager/flags/usa": 824,
	"./services_manager/flags/usa.png": 824,
	"./services_manager/four_tiles/ADV-PLACEMENT/Advanced Placement": 825,
	"./services_manager/four_tiles/ADV-PLACEMENT/Advanced Placement.png": 825,
	"./services_manager/four_tiles/ADV-PLACEMENT/Collaborative Planning": 826,
	"./services_manager/four_tiles/ADV-PLACEMENT/Collaborative Planning.png": 826,
	"./services_manager/four_tiles/ADV-PLACEMENT/School-to-Home Reporting": 827,
	"./services_manager/four_tiles/ADV-PLACEMENT/School-to-Home Reporting.png": 827,
	"./services_manager/four_tiles/ADV-PLACEMENT/Student Portfolios": 828,
	"./services_manager/four_tiles/ADV-PLACEMENT/Student Portfolios.png": 828,
	"./services_manager/four_tiles/AN-AR/Differentiated Tasks": 829,
	"./services_manager/four_tiles/AN-AR/Differentiated Tasks.png": 829,
	"./services_manager/four_tiles/AN-AR/Formative _ Summative Assessments": 830,
	"./services_manager/four_tiles/AN-AR/Formative _ Summative Assessments.png": 830,
	"./services_manager/four_tiles/AN-AR/Gradebook": 831,
	"./services_manager/four_tiles/AN-AR/Gradebook.png": 831,
	"./services_manager/four_tiles/AN-AR/Report Cards": 832,
	"./services_manager/four_tiles/AN-AR/Report Cards.png": 832,
	"./services_manager/four_tiles/AN-CPN/Align to your Standards": 833,
	"./services_manager/four_tiles/AN-CPN/Align to your Standards.png": 833,
	"./services_manager/four_tiles/AN-CPN/Analyze Curriculum": 834,
	"./services_manager/four_tiles/AN-CPN/Analyze Curriculum.png": 834,
	"./services_manager/four_tiles/AN-CPN/Browse your School Curriculum": 835,
	"./services_manager/four_tiles/AN-CPN/Browse your School Curriculum.png": 835,
	"./services_manager/four_tiles/AN-CPN/Collaborate": 836,
	"./services_manager/four_tiles/AN-CPN/Collaborate.png": 836,
	"./services_manager/four_tiles/AN-TL/Flipped Classroom": 837,
	"./services_manager/four_tiles/AN-TL/Flipped Classroom.png": 837,
	"./services_manager/four_tiles/AN-TL/In-Class Instruction": 838,
	"./services_manager/four_tiles/AN-TL/In-Class Instruction.png": 838,
	"./services_manager/four_tiles/AN-TL/Learning Solution": 839,
	"./services_manager/four_tiles/AN-TL/Learning Solution.png": 839,
	"./services_manager/four_tiles/AN-TL/Student Portfolio": 840,
	"./services_manager/four_tiles/AN-TL/Student Portfolio.png": 840,
	"./services_manager/four_tiles/AP-MYP/Exam Proctor Mobile App": 841,
	"./services_manager/four_tiles/AP-MYP/Exam Proctor Mobile App.png": 841,
	"./services_manager/four_tiles/AP-MYP/Flipped Classroom": 842,
	"./services_manager/four_tiles/AP-MYP/Flipped Classroom.png": 842,
	"./services_manager/four_tiles/AP-MYP/No More Messy Handwriting": 843,
	"./services_manager/four_tiles/AP-MYP/No More Messy Handwriting.png": 843,
	"./services_manager/four_tiles/AP-MYP/Online _ Offline Exams": 844,
	"./services_manager/four_tiles/AP-MYP/Online _ Offline Exams.png": 844,
	"./services_manager/four_tiles/APPLUS/Exam Proctor Mobile App": 845,
	"./services_manager/four_tiles/APPLUS/Exam Proctor Mobile App.png": 845,
	"./services_manager/four_tiles/APPLUS/Flipped Classroom": 846,
	"./services_manager/four_tiles/APPLUS/Flipped Classroom.png": 846,
	"./services_manager/four_tiles/APPLUS/No More Messy Handwriting": 847,
	"./services_manager/four_tiles/APPLUS/No More Messy Handwriting.png": 847,
	"./services_manager/four_tiles/APPLUS/Online _ Offline Exams": 848,
	"./services_manager/four_tiles/APPLUS/Online _ Offline Exams.png": 848,
	"./services_manager/four_tiles/APSTD/Exam Proctor Mobile App": 849,
	"./services_manager/four_tiles/APSTD/Exam Proctor Mobile App.png": 849,
	"./services_manager/four_tiles/APSTD/Flipped Classroom": 850,
	"./services_manager/four_tiles/APSTD/Flipped Classroom.png": 850,
	"./services_manager/four_tiles/APSTD/No More Messy Handwriting": 851,
	"./services_manager/four_tiles/APSTD/No More Messy Handwriting.png": 851,
	"./services_manager/four_tiles/APSTD/Online _ Offline Exams": 852,
	"./services_manager/four_tiles/APSTD/Online _ Offline Exams.png": 852,
	"./services_manager/four_tiles/ATLAS_STUDENT/Align to your Standards": 853,
	"./services_manager/four_tiles/ATLAS_STUDENT/Align to your Standards.png": 853,
	"./services_manager/four_tiles/ATLAS_STUDENT/Analyze Curriculum": 854,
	"./services_manager/four_tiles/ATLAS_STUDENT/Analyze Curriculum.png": 854,
	"./services_manager/four_tiles/ATLAS_STUDENT/Browse your School Curriculum": 855,
	"./services_manager/four_tiles/ATLAS_STUDENT/Browse your School Curriculum.png": 855,
	"./services_manager/four_tiles/ATLAS_STUDENT/Collaborate": 856,
	"./services_manager/four_tiles/ATLAS_STUDENT/Collaborate.png": 856,
	"./services_manager/four_tiles/Attendance/Attendance Daily Digest": 857,
	"./services_manager/four_tiles/Attendance/Attendance Daily Digest.png": 857,
	"./services_manager/four_tiles/Attendance/Attendance Manager": 858,
	"./services_manager/four_tiles/Attendance/Attendance Manager.png": 858,
	"./services_manager/four_tiles/Attendance/Homeroom _ Lesson Attendance": 859,
	"./services_manager/four_tiles/Attendance/Homeroom _ Lesson Attendance.png": 859,
	"./services_manager/four_tiles/Attendance/Student Engagement Analytics": 860,
	"./services_manager/four_tiles/Attendance/Student Engagement Analytics.png": 860,
	"./services_manager/four_tiles/BRIDGEU/Connect with global universities": 861,
	"./services_manager/four_tiles/BRIDGEU/Connect with global universities.png": 861,
	"./services_manager/four_tiles/BRIDGEU/Easy application preparation": 862,
	"./services_manager/four_tiles/BRIDGEU/Easy application preparation.png": 862,
	"./services_manager/four_tiles/BRIDGEU/Real time insights _ reporting": 863,
	"./services_manager/four_tiles/BRIDGEU/Real time insights _ reporting.png": 863,
	"./services_manager/four_tiles/BRIDGEU/University _ career exploration": 864,
	"./services_manager/four_tiles/BRIDGEU/University _ career exploration.png": 864,
	"./services_manager/four_tiles/CAM-ADV/Cambridge": 865,
	"./services_manager/four_tiles/CAM-ADV/Cambridge.png": 865,
	"./services_manager/four_tiles/CAM-ADV/Collaborative Planning": 866,
	"./services_manager/four_tiles/CAM-ADV/Collaborative Planning.png": 866,
	"./services_manager/four_tiles/CAM-ADV/School-to-Home Reporting": 867,
	"./services_manager/four_tiles/CAM-ADV/School-to-Home Reporting.png": 867,
	"./services_manager/four_tiles/CAM-ADV/Student Portfolios": 868,
	"./services_manager/four_tiles/CAM-ADV/Student Portfolios.png": 868,
	"./services_manager/four_tiles/CAM-IGCSE/Cambridge": 869,
	"./services_manager/four_tiles/CAM-IGCSE/Cambridge.png": 869,
	"./services_manager/four_tiles/CAM-IGCSE/Collaborative Planning": 870,
	"./services_manager/four_tiles/CAM-IGCSE/Collaborative Planning.png": 870,
	"./services_manager/four_tiles/CAM-IGCSE/School-to-Home Reporting": 871,
	"./services_manager/four_tiles/CAM-IGCSE/School-to-Home Reporting.png": 871,
	"./services_manager/four_tiles/CAM-IGCSE/Student Portfolios": 872,
	"./services_manager/four_tiles/CAM-IGCSE/Student Portfolios.png": 872,
	"./services_manager/four_tiles/CAM-LS/Cambridge": 873,
	"./services_manager/four_tiles/CAM-LS/Cambridge.png": 873,
	"./services_manager/four_tiles/CAM-LS/Collaborative Planning": 874,
	"./services_manager/four_tiles/CAM-LS/Collaborative Planning.png": 874,
	"./services_manager/four_tiles/CAM-LS/School-to-Home Reporting": 875,
	"./services_manager/four_tiles/CAM-LS/School-to-Home Reporting.png": 875,
	"./services_manager/four_tiles/CAM-LS/Student Portfolios": 876,
	"./services_manager/four_tiles/CAM-LS/Student Portfolios.png": 876,
	"./services_manager/four_tiles/CP/MB for Mobile": 877,
	"./services_manager/four_tiles/CP/MB for Mobile.png": 877,
	"./services_manager/four_tiles/CP/Manage the CP": 878,
	"./services_manager/four_tiles/CP/Manage the CP.png": 878,
	"./services_manager/four_tiles/CP/Reflective Project _ Language Portfolio": 879,
	"./services_manager/four_tiles/CP/Reflective Project _ Language Portfolio.png": 879,
	"./services_manager/four_tiles/CP/Service Learning": 880,
	"./services_manager/four_tiles/CP/Service Learning.png": 880,
	"./services_manager/four_tiles/CT-AR/Differentiated Tasks": 881,
	"./services_manager/four_tiles/CT-AR/Differentiated Tasks.png": 881,
	"./services_manager/four_tiles/CT-AR/Formative _ Summative Assessments": 882,
	"./services_manager/four_tiles/CT-AR/Formative _ Summative Assessments.png": 882,
	"./services_manager/four_tiles/CT-AR/Gradebook": 883,
	"./services_manager/four_tiles/CT-AR/Gradebook.png": 883,
	"./services_manager/four_tiles/CT-AR/Report Cards": 884,
	"./services_manager/four_tiles/CT-AR/Report Cards.png": 884,
	"./services_manager/four_tiles/CT-CPN/Align to your Standards": 885,
	"./services_manager/four_tiles/CT-CPN/Align to your Standards.png": 885,
	"./services_manager/four_tiles/CT-CPN/Analyze Curriculum": 886,
	"./services_manager/four_tiles/CT-CPN/Analyze Curriculum.png": 886,
	"./services_manager/four_tiles/CT-CPN/Browse your School Curriculum": 887,
	"./services_manager/four_tiles/CT-CPN/Browse your School Curriculum.png": 887,
	"./services_manager/four_tiles/CT-CPN/Collaborate": 888,
	"./services_manager/four_tiles/CT-CPN/Collaborate.png": 888,
	"./services_manager/four_tiles/CT-TL/Flipped Classroom": 889,
	"./services_manager/four_tiles/CT-TL/Flipped Classroom.png": 889,
	"./services_manager/four_tiles/CT-TL/In-Class Instruction": 890,
	"./services_manager/four_tiles/CT-TL/In-Class Instruction.png": 890,
	"./services_manager/four_tiles/CT-TL/Learning Solution": 891,
	"./services_manager/four_tiles/CT-TL/Learning Solution.png": 891,
	"./services_manager/four_tiles/CT-TL/Student Portfolio": 892,
	"./services_manager/four_tiles/CT-TL/Student Portfolio.png": 892,
	"./services_manager/four_tiles/CUR-CH/Collaborative Conversation": 893,
	"./services_manager/four_tiles/CUR-CH/Collaborative Conversation.png": 893,
	"./services_manager/four_tiles/CUR-CH/Curriculum Coaching": 894,
	"./services_manager/four_tiles/CUR-CH/Curriculum Coaching.png": 894,
	"./services_manager/four_tiles/CUR-CH/Curriculum Development": 895,
	"./services_manager/four_tiles/CUR-CH/Curriculum Development.png": 895,
	"./services_manager/four_tiles/CUR-CH/School Leadership _ Process": 896,
	"./services_manager/four_tiles/CUR-CH/School Leadership _ Process.png": 896,
	"./services_manager/four_tiles/DPCORE/Creativity, Activity _ Service": 897,
	"./services_manager/four_tiles/DPCORE/Creativity, Activity _ Service.png": 897,
	"./services_manager/four_tiles/DPCORE/Extended Essay": 898,
	"./services_manager/four_tiles/DPCORE/Extended Essay.png": 898,
	"./services_manager/four_tiles/DPCORE/IB Deadlines": 899,
	"./services_manager/four_tiles/DPCORE/IB Deadlines.png": 899,
	"./services_manager/four_tiles/DPCORE/MB for Mobile": 900,
	"./services_manager/four_tiles/DPCORE/MB for Mobile.png": 900,
	"./services_manager/four_tiles/DPPRO/Diploma Core": 901,
	"./services_manager/four_tiles/DPPRO/Diploma Core.png": 901,
	"./services_manager/four_tiles/DPPRO/IAs _ eCoursework": 902,
	"./services_manager/four_tiles/DPPRO/IAs _ eCoursework.png": 902,
	"./services_manager/four_tiles/DPPRO/IB Deadlines": 903,
	"./services_manager/four_tiles/DPPRO/IB Deadlines.png": 903,
	"./services_manager/four_tiles/DPPRO/MB for Mobile": 904,
	"./services_manager/four_tiles/DPPRO/MB for Mobile.png": 904,
	"./services_manager/four_tiles/FARIA1/All-in-One Systems": 905,
	"./services_manager/four_tiles/FARIA1/All-in-One Systems.png": 905,
	"./services_manager/four_tiles/FARIA1/Built for International Schools": 906,
	"./services_manager/four_tiles/FARIA1/Built for International Schools.png": 906,
	"./services_manager/four_tiles/FARIA1/Integrated Architecture": 907,
	"./services_manager/four_tiles/FARIA1/Integrated Architecture.png": 907,
	"./services_manager/four_tiles/FARIA1/Multi-Curricula": 908,
	"./services_manager/four_tiles/FARIA1/Multi-Curricula.png": 908,
	"./services_manager/four_tiles/FARIA1PLUS/All-in-One Systems": 909,
	"./services_manager/four_tiles/FARIA1PLUS/All-in-One Systems.png": 909,
	"./services_manager/four_tiles/FARIA1PLUS/Built for International Schools": 910,
	"./services_manager/four_tiles/FARIA1PLUS/Built for International Schools.png": 910,
	"./services_manager/four_tiles/FARIA1PLUS/Integrated Architecture": 911,
	"./services_manager/four_tiles/FARIA1PLUS/Integrated Architecture.png": 911,
	"./services_manager/four_tiles/FARIA1PLUS/Multi-Curricula": 912,
	"./services_manager/four_tiles/FARIA1PLUS/Multi-Curricula.png": 912,
	"./services_manager/four_tiles/FARIA1STD/All-in-One Systems": 913,
	"./services_manager/four_tiles/FARIA1STD/All-in-One Systems.png": 913,
	"./services_manager/four_tiles/FARIA1STD/Built for International Schools": 914,
	"./services_manager/four_tiles/FARIA1STD/Built for International Schools.png": 914,
	"./services_manager/four_tiles/FARIA1STD/Integrated Architecture": 915,
	"./services_manager/four_tiles/FARIA1STD/Integrated Architecture.png": 915,
	"./services_manager/four_tiles/FARIA1STD/Multi-Curricula": 916,
	"./services_manager/four_tiles/FARIA1STD/Multi-Curricula.png": 916,
	"./services_manager/four_tiles/HIGH/Collaborative Planning": 917,
	"./services_manager/four_tiles/HIGH/Collaborative Planning.png": 917,
	"./services_manager/four_tiles/HIGH/High School Curriculum": 918,
	"./services_manager/four_tiles/HIGH/High School Curriculum.png": 918,
	"./services_manager/four_tiles/HIGH/School-to-Home Reporting": 919,
	"./services_manager/four_tiles/HIGH/School-to-Home Reporting.png": 919,
	"./services_manager/four_tiles/HIGH/Student Portfolios": 920,
	"./services_manager/four_tiles/HIGH/Student Portfolios.png": 920,
	"./services_manager/four_tiles/IDAT/Find The Right Applicants": 921,
	"./services_manager/four_tiles/IDAT/Find The Right Applicants.png": 921,
	"./services_manager/four_tiles/IDAT/International Student Testing": 922,
	"./services_manager/four_tiles/IDAT/International Student Testing.png": 922,
	"./services_manager/four_tiles/IDAT/Sync to Checklist Requirement": 923,
	"./services_manager/four_tiles/IDAT/Sync to Checklist Requirement.png": 923,
	"./services_manager/four_tiles/IDAT/Test Centers Around the World": 924,
	"./services_manager/four_tiles/IDAT/Test Centers Around the World.png": 924,
	"./services_manager/four_tiles/IDATCONCISE/Fast _ Accurate Assessment": 925,
	"./services_manager/four_tiles/IDATCONCISE/Fast _ Accurate Assessment.png": 925,
	"./services_manager/four_tiles/IDATCONCISE/Find the Right Applicants": 926,
	"./services_manager/four_tiles/IDATCONCISE/Find the Right Applicants.png": 926,
	"./services_manager/four_tiles/IDATCONCISE/International Student Testing": 927,
	"./services_manager/four_tiles/IDATCONCISE/International Student Testing.png": 927,
	"./services_manager/four_tiles/IDATCONCISE/Streamlined Online Process": 928,
	"./services_manager/four_tiles/IDATCONCISE/Streamlined Online Process.png": 928,
	"./services_manager/four_tiles/KEYCHAT/Advisory": 929,
	"./services_manager/four_tiles/KEYCHAT/Advisory.png": 929,
	"./services_manager/four_tiles/KEYCHAT/Bulletin": 930,
	"./services_manager/four_tiles/KEYCHAT/Bulletin.png": 930,
	"./services_manager/four_tiles/KEYCHAT/Email": 931,
	"./services_manager/four_tiles/KEYCHAT/Email.png": 931,
	"./services_manager/four_tiles/KEYCHAT/Student Group _ Project": 932,
	"./services_manager/four_tiles/KEYCHAT/Student Group _ Project.png": 932,
	"./services_manager/four_tiles/MB_CHAT/Built-in Safeguarding": 933,
	"./services_manager/four_tiles/MB_CHAT/Built-in Safeguarding.png": 933,
	"./services_manager/four_tiles/MB_CHAT/Direct Messaging": 934,
	"./services_manager/four_tiles/MB_CHAT/Direct Messaging.png": 934,
	"./services_manager/four_tiles/MB_CHAT/Flexible Permissions": 935,
	"./services_manager/four_tiles/MB_CHAT/Flexible Permissions.png": 935,
	"./services_manager/four_tiles/MB_CHAT/Group Messaging _Coming Soon_": 936,
	"./services_manager/four_tiles/MB_CHAT/Group Messaging _Coming Soon_.png": 936,
	"./services_manager/four_tiles/MB_MAX/1-1 Direct Messaging": 937,
	"./services_manager/four_tiles/MB_MAX/1-1 Direct Messaging.png": 937,
	"./services_manager/four_tiles/MB_MAX/Attendance": 938,
	"./services_manager/four_tiles/MB_MAX/Attendance.png": 938,
	"./services_manager/four_tiles/MB_MAX/Behavior & Discipline": 939,
	"./services_manager/four_tiles/MB_MAX/Behavior & Discipline.svg": 939,
	"./services_manager/four_tiles/MB_MAX/Behavior and Discipline": 940,
	"./services_manager/four_tiles/MB_MAX/Behavior and Discipline.png": 940,
	"./services_manager/four_tiles/MB_MAX/KeyChat Premium _coming soon_": 941,
	"./services_manager/four_tiles/MB_MAX/KeyChat Premium _coming soon_.png": 941,
	"./services_manager/four_tiles/MB_MAX/Online Assessment Tool _AssessPrep_": 942,
	"./services_manager/four_tiles/MB_MAX/Online Assessment Tool _AssessPrep_.png": 942,
	"./services_manager/four_tiles/MB_MAX/Reporting": 943,
	"./services_manager/four_tiles/MB_MAX/Reporting.png": 943,
	"./services_manager/four_tiles/MB_MAX/SEL _coming soon_": 944,
	"./services_manager/four_tiles/MB_MAX/SEL _coming soon_.png": 944,
	"./services_manager/four_tiles/MB_PASSPORT/Exam Question Bank": 945,
	"./services_manager/four_tiles/MB_PASSPORT/Exam Question Bank.png": 945,
	"./services_manager/four_tiles/MB_PASSPORT/Learning Management": 946,
	"./services_manager/four_tiles/MB_PASSPORT/Learning Management.png": 946,
	"./services_manager/four_tiles/MB_PASSPORT/Online Assessment": 947,
	"./services_manager/four_tiles/MB_PASSPORT/Online Assessment.png": 947,
	"./services_manager/four_tiles/MB_PASSPORT/Pre-Built Curriculum": 948,
	"./services_manager/four_tiles/MB_PASSPORT/Pre-Built Curriculum.png": 948,
	"./services_manager/four_tiles/MB_PASSPORT/Professional Development": 949,
	"./services_manager/four_tiles/MB_PASSPORT/Professional Development.png": 949,
	"./services_manager/four_tiles/MB_PASSPORT/Study _ Revision": 950,
	"./services_manager/four_tiles/MB_PASSPORT/Study _ Revision.png": 950,
	"./services_manager/four_tiles/MB_PRO/1-1 Direct Messaging": 951,
	"./services_manager/four_tiles/MB_PRO/1-1 Direct Messaging.png": 951,
	"./services_manager/four_tiles/MB_PRO/Attendance": 952,
	"./services_manager/four_tiles/MB_PRO/Attendance.png": 952,
	"./services_manager/four_tiles/MB_PRO/Behavior and Discipline": 953,
	"./services_manager/four_tiles/MB_PRO/Behavior and Discipline.png": 953,
	"./services_manager/four_tiles/MB_PRO/Reporting": 954,
	"./services_manager/four_tiles/MB_PRO/Reporting.png": 954,
	"./services_manager/four_tiles/MIDDLE/Collaborative Planning": 955,
	"./services_manager/four_tiles/MIDDLE/Collaborative Planning.png": 955,
	"./services_manager/four_tiles/MIDDLE/Middle School Curriculum": 956,
	"./services_manager/four_tiles/MIDDLE/Middle School Curriculum.png": 956,
	"./services_manager/four_tiles/MIDDLE/School-to-Home Reporting": 957,
	"./services_manager/four_tiles/MIDDLE/School-to-Home Reporting.png": 957,
	"./services_manager/four_tiles/MIDDLE/Student Portfolios": 958,
	"./services_manager/four_tiles/MIDDLE/Student Portfolios.png": 958,
	"./services_manager/four_tiles/MPD_ALL/Equitable Access": 959,
	"./services_manager/four_tiles/MPD_ALL/Equitable Access.png": 959,
	"./services_manager/four_tiles/MPD_ALL/Global Connections": 960,
	"./services_manager/four_tiles/MPD_ALL/Global Connections.png": 960,
	"./services_manager/four_tiles/MPD_ALL/Intentionally Designed": 961,
	"./services_manager/four_tiles/MPD_ALL/Intentionally Designed.png": 961,
	"./services_manager/four_tiles/MPD_ALL/University Recognition": 962,
	"./services_manager/four_tiles/MPD_ALL/University Recognition.png": 962,
	"./services_manager/four_tiles/MPD_MYP/Equitable Access": 963,
	"./services_manager/four_tiles/MPD_MYP/Equitable Access.png": 963,
	"./services_manager/four_tiles/MPD_MYP/Global Connections": 964,
	"./services_manager/four_tiles/MPD_MYP/Global Connections.png": 964,
	"./services_manager/four_tiles/MPD_MYP/Intentionally Designed": 965,
	"./services_manager/four_tiles/MPD_MYP/Intentionally Designed.png": 965,
	"./services_manager/four_tiles/MPD_MYP/University Recognition": 966,
	"./services_manager/four_tiles/MPD_MYP/University Recognition.png": 966,
	"./services_manager/four_tiles/MPD_PYP/Equitable Access": 967,
	"./services_manager/four_tiles/MPD_PYP/Equitable Access.png": 967,
	"./services_manager/four_tiles/MPD_PYP/Global Connections": 968,
	"./services_manager/four_tiles/MPD_PYP/Global Connections.png": 968,
	"./services_manager/four_tiles/MPD_PYP/Intentionally Designed": 969,
	"./services_manager/four_tiles/MPD_PYP/Intentionally Designed.png": 969,
	"./services_manager/four_tiles/MPD_PYP/University Recognition": 970,
	"./services_manager/four_tiles/MPD_PYP/University Recognition.png": 970,
	"./services_manager/four_tiles/MYP/Collaborative Planning": 971,
	"./services_manager/four_tiles/MYP/Collaborative Planning.png": 971,
	"./services_manager/four_tiles/MYP/Interdisciplinary Assessment": 972,
	"./services_manager/four_tiles/MYP/Interdisciplinary Assessment.png": 972,
	"./services_manager/four_tiles/MYP/Manage the MYP": 973,
	"./services_manager/four_tiles/MYP/Manage the MYP.png": 973,
	"./services_manager/four_tiles/MYP/Student Portfolios": 974,
	"./services_manager/four_tiles/MYP/Student Portfolios.png": 974,
	"./services_manager/four_tiles/OA/Admissions Analytics": 975,
	"./services_manager/four_tiles/OA/Admissions Analytics.png": 975,
	"./services_manager/four_tiles/OA/Applicant Review": 976,
	"./services_manager/four_tiles/OA/Applicant Review.png": 976,
	"./services_manager/four_tiles/OA/Collect Documents and Payments": 977,
	"./services_manager/four_tiles/OA/Collect Documents and Payments.png": 977,
	"./services_manager/four_tiles/OA/Conditional Checklists": 978,
	"./services_manager/four_tiles/OA/Conditional Checklists.png": 978,
	"./services_manager/four_tiles/OASD/Families Discover your School": 979,
	"./services_manager/four_tiles/OASD/Families Discover your School.png": 979,
	"./services_manager/four_tiles/OASD/Receive Enquiries": 980,
	"./services_manager/four_tiles/OASD/Receive Enquiries.png": 980,
	"./services_manager/four_tiles/OASD/Unique School Profile": 981,
	"./services_manager/four_tiles/OASD/Unique School Profile.png": 981,
	"./services_manager/four_tiles/OASD/Worldwide School Directory": 982,
	"./services_manager/four_tiles/OASD/Worldwide School Directory.png": 982,
	"./services_manager/four_tiles/OA_CRM/Click Rate Tracking": 983,
	"./services_manager/four_tiles/OA_CRM/Click Rate Tracking.png": 983,
	"./services_manager/four_tiles/OA_CRM/Email Campaigns": 984,
	"./services_manager/four_tiles/OA_CRM/Email Campaigns.png": 984,
	"./services_manager/four_tiles/OA_CRM/Indicator Logs": 985,
	"./services_manager/four_tiles/OA_CRM/Indicator Logs.png": 985,
	"./services_manager/four_tiles/OA_CRM/Marketing Analytics": 986,
	"./services_manager/four_tiles/OA_CRM/Marketing Analytics.png": 986,
	"./services_manager/four_tiles/OSCAPP/Access from Any Device": 987,
	"./services_manager/four_tiles/OSCAPP/Access from Any Device.png": 987,
	"./services_manager/four_tiles/OSCAPP/Content from Leading IB Authors": 988,
	"./services_manager/four_tiles/OSCAPP/Content from Leading IB Authors.png": 988,
	"./services_manager/four_tiles/OSCAPP/Notes, Folders, and Search": 989,
	"./services_manager/four_tiles/OSCAPP/Notes, Folders, and Search.png": 989,
	"./services_manager/four_tiles/OSCAPP/Smart Digital Content": 990,
	"./services_manager/four_tiles/OSCAPP/Smart Digital Content.png": 990,
	"./services_manager/four_tiles/PEA-ADV/Collaborative Planning": 991,
	"./services_manager/four_tiles/PEA-ADV/Collaborative Planning.png": 991,
	"./services_manager/four_tiles/PEA-ADV/Pearson Edexcel": 992,
	"./services_manager/four_tiles/PEA-ADV/Pearson Edexcel.png": 992,
	"./services_manager/four_tiles/PEA-ADV/School-to-Home Reporting": 993,
	"./services_manager/four_tiles/PEA-ADV/School-to-Home Reporting.png": 993,
	"./services_manager/four_tiles/PEA-ADV/Student Portfolios": 994,
	"./services_manager/four_tiles/PEA-ADV/Student Portfolios.png": 994,
	"./services_manager/four_tiles/PEA-EDE/Collaborative Planning": 995,
	"./services_manager/four_tiles/PEA-EDE/Collaborative Planning.png": 995,
	"./services_manager/four_tiles/PEA-EDE/Pearson Edexcel": 996,
	"./services_manager/four_tiles/PEA-EDE/Pearson Edexcel.png": 996,
	"./services_manager/four_tiles/PEA-EDE/School-to-Home Reporting": 997,
	"./services_manager/four_tiles/PEA-EDE/School-to-Home Reporting.png": 997,
	"./services_manager/four_tiles/PEA-EDE/Student Portfolios": 998,
	"./services_manager/four_tiles/PEA-EDE/Student Portfolios.png": 998,
	"./services_manager/four_tiles/PEA-IGCSE/Collaborative Planning": 999,
	"./services_manager/four_tiles/PEA-IGCSE/Collaborative Planning.png": 999,
	"./services_manager/four_tiles/PEA-IGCSE/Pearson Edexcel": 1000,
	"./services_manager/four_tiles/PEA-IGCSE/Pearson Edexcel.png": 1000,
	"./services_manager/four_tiles/PEA-IGCSE/School-to-Home Reporting": 1001,
	"./services_manager/four_tiles/PEA-IGCSE/School-to-Home Reporting.png": 1001,
	"./services_manager/four_tiles/PEA-IGCSE/Student Portfolios": 1002,
	"./services_manager/four_tiles/PEA-IGCSE/Student Portfolios.png": 1002,
	"./services_manager/four_tiles/PMJ_ALEVELS/Adapt Courses to Fit Your School_s Timetable": 1003,
	"./services_manager/four_tiles/PMJ_ALEVELS/Adapt Courses to Fit Your School_s Timetable.png": 1003,
	"./services_manager/four_tiles/PMJ_ALEVELS/Encourage Students to be Collaborative Outside of Lesson Time": 1004,
	"./services_manager/four_tiles/PMJ_ALEVELS/Encourage Students to be Collaborative Outside of Lesson Time.png": 1004,
	"./services_manager/four_tiles/PMJ_ALEVELS/Opportunity to Flip Classroom": 1005,
	"./services_manager/four_tiles/PMJ_ALEVELS/Opportunity to Flip Classroom.png": 1005,
	"./services_manager/four_tiles/PMJ_ALEVELS/Ready to Use Resources": 1006,
	"./services_manager/four_tiles/PMJ_ALEVELS/Ready to Use Resources.png": 1006,
	"./services_manager/four_tiles/PMJ_IB/Curriculum-aligned Content": 1007,
	"./services_manager/four_tiles/PMJ_IB/Curriculum-aligned Content.png": 1007,
	"./services_manager/four_tiles/PMJ_IB/Flexible and Customisable": 1008,
	"./services_manager/four_tiles/PMJ_IB/Flexible and Customisable.png": 1008,
	"./services_manager/four_tiles/PMJ_IB/Global ResourceBank": 1009,
	"./services_manager/four_tiles/PMJ_IB/Global ResourceBank.png": 1009,
	"./services_manager/four_tiles/PMJ_IB/Turnkey Curriculum": 1010,
	"./services_manager/four_tiles/PMJ_IB/Turnkey Curriculum.png": 1010,
	"./services_manager/four_tiles/PMJ_IGCSE/Adapt Courses to Fit Your School_s Timetable": 1011,
	"./services_manager/four_tiles/PMJ_IGCSE/Adapt Courses to Fit Your School_s Timetable.png": 1011,
	"./services_manager/four_tiles/PMJ_IGCSE/Encourage Students to be Collaborative Outside of Lesson Time": 1012,
	"./services_manager/four_tiles/PMJ_IGCSE/Encourage Students to be Collaborative Outside of Lesson Time.png": 1012,
	"./services_manager/four_tiles/PMJ_IGCSE/Opportunity to Flip Classroom": 1013,
	"./services_manager/four_tiles/PMJ_IGCSE/Opportunity to Flip Classroom.png": 1013,
	"./services_manager/four_tiles/PMJ_IGCSE/Ready to Use Resources": 1014,
	"./services_manager/four_tiles/PMJ_IGCSE/Ready to Use Resources.png": 1014,
	"./services_manager/four_tiles/POC-A-Level/Curriculum-aligned": 1015,
	"./services_manager/four_tiles/POC-A-Level/Curriculum-aligned.png": 1015,
	"./services_manager/four_tiles/POC-A-Level/Progress Monitoring": 1016,
	"./services_manager/four_tiles/POC-A-Level/Progress Monitoring.png": 1016,
	"./services_manager/four_tiles/POC-A-Level/Student-centred and collaborative": 1017,
	"./services_manager/four_tiles/POC-A-Level/Student-centred and collaborative.png": 1017,
	"./services_manager/four_tiles/POC-A-Level/Teacher Supported": 1018,
	"./services_manager/four_tiles/POC-A-Level/Teacher Supported.png": 1018,
	"./services_manager/four_tiles/POC-IB/Curriculum-aligned": 1019,
	"./services_manager/four_tiles/POC-IB/Curriculum-aligned.png": 1019,
	"./services_manager/four_tiles/POC-IB/Progress Monitoring": 1020,
	"./services_manager/four_tiles/POC-IB/Progress Monitoring.png": 1020,
	"./services_manager/four_tiles/POC-IB/Student-centred and collaborative": 1021,
	"./services_manager/four_tiles/POC-IB/Student-centred and collaborative.png": 1021,
	"./services_manager/four_tiles/POC-IB/Teacher Supported": 1022,
	"./services_manager/four_tiles/POC-IB/Teacher Supported.png": 1022,
	"./services_manager/four_tiles/POC-IGCSE/Curriculum-aligned": 1023,
	"./services_manager/four_tiles/POC-IGCSE/Curriculum-aligned.png": 1023,
	"./services_manager/four_tiles/POC-IGCSE/Progress Monitoring": 1024,
	"./services_manager/four_tiles/POC-IGCSE/Progress Monitoring.png": 1024,
	"./services_manager/four_tiles/POC-IGCSE/Student-centred and collaborative": 1025,
	"./services_manager/four_tiles/POC-IGCSE/Student-centred and collaborative.png": 1025,
	"./services_manager/four_tiles/POC-IGCSE/Teacher Supported": 1026,
	"./services_manager/four_tiles/POC-IGCSE/Teacher Supported.png": 1026,
	"./services_manager/four_tiles/POWERSCHOOL/Automatically Sync to PowerSchool": 1027,
	"./services_manager/four_tiles/POWERSCHOOL/Automatically Sync to PowerSchool.png": 1027,
	"./services_manager/four_tiles/POWERSCHOOL/Map your PowerSchool Fields": 1028,
	"./services_manager/four_tiles/POWERSCHOOL/Map your PowerSchool Fields.png": 1028,
	"./services_manager/four_tiles/POWERSCHOOL/Set Default PowerSchool Enrolment Status": 1029,
	"./services_manager/four_tiles/POWERSCHOOL/Set Default PowerSchool Enrolment Status.png": 1029,
	"./services_manager/four_tiles/POWERSCHOOL/Sync to PowerSchool Custom Fields": 1030,
	"./services_manager/four_tiles/POWERSCHOOL/Sync to PowerSchool Custom Fields.png": 1030,
	"./services_manager/four_tiles/PREMIUM_SUPPORT/Custom Online Trainings": 1031,
	"./services_manager/four_tiles/PREMIUM_SUPPORT/Custom Online Trainings.png": 1031,
	"./services_manager/four_tiles/PREMIUM_SUPPORT/Ongoing Faculty _ Course Support": 1032,
	"./services_manager/four_tiles/PREMIUM_SUPPORT/Ongoing Faculty _ Course Support.png": 1032,
	"./services_manager/four_tiles/PREMIUM_SUPPORT/Prioritized Support": 1033,
	"./services_manager/four_tiles/PREMIUM_SUPPORT/Prioritized Support.png": 1033,
	"./services_manager/four_tiles/PREMIUM_SUPPORT/Template updates": 1034,
	"./services_manager/four_tiles/PREMIUM_SUPPORT/Template updates.png": 1034,
	"./services_manager/four_tiles/PRIMARY/Collaborative Planning": 1035,
	"./services_manager/four_tiles/PRIMARY/Collaborative Planning.png": 1035,
	"./services_manager/four_tiles/PRIMARY/Primary School Curriculum": 1036,
	"./services_manager/four_tiles/PRIMARY/Primary School Curriculum.png": 1036,
	"./services_manager/four_tiles/PRIMARY/School-to-Home Reporting": 1037,
	"./services_manager/four_tiles/PRIMARY/School-to-Home Reporting.png": 1037,
	"./services_manager/four_tiles/PRIMARY/Student Portfolios": 1038,
	"./services_manager/four_tiles/PRIMARY/Student Portfolios.png": 1038,
	"./services_manager/four_tiles/PYP/Collaborative Planning": 1039,
	"./services_manager/four_tiles/PYP/Collaborative Planning.png": 1039,
	"./services_manager/four_tiles/PYP/Manage the PYP": 1040,
	"./services_manager/four_tiles/PYP/Manage the PYP.png": 1040,
	"./services_manager/four_tiles/PYP/School-to-Home Reporting": 1041,
	"./services_manager/four_tiles/PYP/School-to-Home Reporting.png": 1041,
	"./services_manager/four_tiles/PYP/Student Portfolios": 1042,
	"./services_manager/four_tiles/PYP/Student Portfolios.png": 1042,
	"./services_manager/four_tiles/Reports/Customisable Templates _ Styles": 1043,
	"./services_manager/four_tiles/Reports/Customisable Templates _ Styles.png": 1043,
	"./services_manager/four_tiles/Reports/Multi-Curricula Support": 1044,
	"./services_manager/four_tiles/Reports/Multi-Curricula Support.png": 1044,
	"./services_manager/four_tiles/Reports/Paperless Report Cards": 1045,
	"./services_manager/four_tiles/Reports/Paperless Report Cards.png": 1045,
	"./services_manager/four_tiles/Reports/Student Reflection _ Portfolio": 1046,
	"./services_manager/four_tiles/Reports/Student Reflection _ Portfolio.png": 1046,
	"./services_manager/four_tiles/SB-LF-ACTIVITIES-001/Auto-Allocation in Seconds": 1047,
	"./services_manager/four_tiles/SB-LF-ACTIVITIES-001/Auto-Allocation in Seconds.png": 1047,
	"./services_manager/four_tiles/SB-LF-ACTIVITIES-001/Organise Complex Activity Programmes": 1048,
	"./services_manager/four_tiles/SB-LF-ACTIVITIES-001/Organise Complex Activity Programmes.png": 1048,
	"./services_manager/four_tiles/SB-LF-ACTIVITIES-001/Preference Based Sign Ups": 1049,
	"./services_manager/four_tiles/SB-LF-ACTIVITIES-001/Preference Based Sign Ups.png": 1049,
	"./services_manager/four_tiles/SB-LF-ACTIVITIES-001/Sports Team Management": 1050,
	"./services_manager/four_tiles/SB-LF-ACTIVITIES-001/Sports Team Management.png": 1050,
	"./services_manager/four_tiles/SB-LF-ACTIVITIES-002/Cap Numbers": 1051,
	"./services_manager/four_tiles/SB-LF-ACTIVITIES-002/Cap Numbers.png": 1051,
	"./services_manager/four_tiles/SB-LF-ACTIVITIES-002/One-Off Events": 1052,
	"./services_manager/four_tiles/SB-LF-ACTIVITIES-002/One-Off Events.png": 1052,
	"./services_manager/four_tiles/SB-LF-ACTIVITIES-002/Optional Parent Payments": 1053,
	"./services_manager/four_tiles/SB-LF-ACTIVITIES-002/Optional Parent Payments.png": 1053,
	"./services_manager/four_tiles/SB-LF-ACTIVITIES-002/Wraparound Care Bookings": 1054,
	"./services_manager/four_tiles/SB-LF-ACTIVITIES-002/Wraparound Care Bookings.png": 1054,
	"./services_manager/four_tiles/SB-LF-COMMUNICATIONS-001/Parent_Student Inbox": 1055,
	"./services_manager/four_tiles/SB-LF-COMMUNICATIONS-001/Parent_Student Inbox.png": 1055,
	"./services_manager/four_tiles/SB-LF-COMMUNICATIONS-001/Save Paper _ Time": 1056,
	"./services_manager/four_tiles/SB-LF-COMMUNICATIONS-001/Save Paper _ Time.png": 1056,
	"./services_manager/four_tiles/SB-LF-COMMUNICATIONS-001/Simple Communications": 1057,
	"./services_manager/four_tiles/SB-LF-COMMUNICATIONS-001/Simple Communications.png": 1057,
	"./services_manager/four_tiles/SB-LF-COMMUNICATIONS-001/Targeted Group Messages": 1058,
	"./services_manager/four_tiles/SB-LF-COMMUNICATIONS-001/Targeted Group Messages.png": 1058,
	"./services_manager/four_tiles/SB-LF-CORE-001/Basic Trip Management": 1059,
	"./services_manager/four_tiles/SB-LF-CORE-001/Basic Trip Management.png": 1059,
	"./services_manager/four_tiles/SB-LF-CORE-001/Built-in Communications": 1060,
	"./services_manager/four_tiles/SB-LF-CORE-001/Built-in Communications.png": 1060,
	"./services_manager/four_tiles/SB-LF-CORE-001/Parent Portal": 1061,
	"./services_manager/four_tiles/SB-LF-CORE-001/Parent Portal.png": 1061,
	"./services_manager/four_tiles/SB-LF-CORE-001/Parent_Student Calendar": 1062,
	"./services_manager/four_tiles/SB-LF-CORE-001/Parent_Student Calendar.png": 1062,
	"./services_manager/four_tiles/SB-LF-ONLINEPAYMENTS-001/Enable Online Payments": 1063,
	"./services_manager/four_tiles/SB-LF-ONLINEPAYMENTS-001/Enable Online Payments.png": 1063,
	"./services_manager/four_tiles/SB-LF-ONLINEPAYMENTS-001/Full Reporting Platform": 1064,
	"./services_manager/four_tiles/SB-LF-ONLINEPAYMENTS-001/Full Reporting Platform.png": 1064,
	"./services_manager/four_tiles/SB-LF-ONLINEPAYMENTS-001/One-Off Billing": 1065,
	"./services_manager/four_tiles/SB-LF-ONLINEPAYMENTS-001/One-Off Billing.png": 1065,
	"./services_manager/four_tiles/SB-LF-ONLINEPAYMENTS-001/Track _ Chase Payments": 1066,
	"./services_manager/four_tiles/SB-LF-ONLINEPAYMENTS-001/Track _ Chase Payments.png": 1066,
	"./services_manager/four_tiles/SB-LF-ONLINEPAYMENTS-002/Full invoicing system": 1067,
	"./services_manager/four_tiles/SB-LF-ONLINEPAYMENTS-002/Full invoicing system.png": 1067,
	"./services_manager/four_tiles/SB-LF-ONLINEPAYMENTS-002/Invoice individuals or companies": 1068,
	"./services_manager/four_tiles/SB-LF-ONLINEPAYMENTS-002/Invoice individuals or companies.png": 1068,
	"./services_manager/four_tiles/SB-LF-ONLINEPAYMENTS-002/Take online payments": 1069,
	"./services_manager/four_tiles/SB-LF-ONLINEPAYMENTS-002/Take online payments.png": 1069,
	"./services_manager/four_tiles/SB-LF-ONLINEPAYMENTS-002/Tracking _ Reporting": 1070,
	"./services_manager/four_tiles/SB-LF-ONLINEPAYMENTS-002/Tracking _ Reporting.png": 1070,
	"./services_manager/four_tiles/SB-LF-PARENTMEETINGS-001/Adaptable for Remote PTCs": 1071,
	"./services_manager/four_tiles/SB-LF-PARENTMEETINGS-001/Adaptable for Remote PTCs.png": 1071,
	"./services_manager/four_tiles/SB-LF-PARENTMEETINGS-001/Easy Parent Bookings": 1072,
	"./services_manager/four_tiles/SB-LF-PARENTMEETINGS-001/Easy Parent Bookings.png": 1072,
	"./services_manager/four_tiles/SB-LF-PARENTMEETINGS-001/Staff Schedules": 1073,
	"./services_manager/four_tiles/SB-LF-PARENTMEETINGS-001/Staff Schedules.png": 1073,
	"./services_manager/four_tiles/SB-LF-PARENTMEETINGS-001/Tracking _ Reporting": 1074,
	"./services_manager/four_tiles/SB-LF-PARENTMEETINGS-001/Tracking _ Reporting.png": 1074,
	"./services_manager/four_tiles/SB-LF-Transport-002/Daily Transport Lists": 1075,
	"./services_manager/four_tiles/SB-LF-Transport-002/Daily Transport Lists.png": 1075,
	"./services_manager/four_tiles/SB-LF-Transport-002/Dynamic Adjustments": 1076,
	"./services_manager/four_tiles/SB-LF-Transport-002/Dynamic Adjustments.png": 1076,
	"./services_manager/four_tiles/SB-LF-Transport-002/Mobile Attendance": 1077,
	"./services_manager/four_tiles/SB-LF-Transport-002/Mobile Attendance.png": 1077,
	"./services_manager/four_tiles/SB-LF-Transport-002/Parent Change Requests": 1078,
	"./services_manager/four_tiles/SB-LF-Transport-002/Parent Change Requests.png": 1078,
	"./services_manager/four_tiles/SIMSEPORT/Easily Lookup SIMS Fields": 1079,
	"./services_manager/four_tiles/SIMSEPORT/Easily Lookup SIMS Fields.png": 1079,
	"./services_manager/four_tiles/SIMSEPORT/Easily Upload to SIMS": 1080,
	"./services_manager/four_tiles/SIMSEPORT/Easily Upload to SIMS.png": 1080,
	"./services_manager/four_tiles/SIMSEPORT/Map your SIMS Fields": 1081,
	"./services_manager/four_tiles/SIMSEPORT/Map your SIMS Fields.png": 1081,
	"./services_manager/four_tiles/SIMSEPORT/Set Option and Mandatory SIMS Fields": 1082,
	"./services_manager/four_tiles/SIMSEPORT/Set Option and Mandatory SIMS Fields.png": 1082,
	"./services_manager/four_tiles/SPECIALREPORT/Customize to your Needs": 1083,
	"./services_manager/four_tiles/SPECIALREPORT/Customize to your Needs.png": 1083,
	"./services_manager/four_tiles/SPECIALREPORT/Monthly Analytics": 1084,
	"./services_manager/four_tiles/SPECIALREPORT/Monthly Analytics.png": 1084,
	"./services_manager/four_tiles/SPECIALREPORT/Review at a Glance": 1085,
	"./services_manager/four_tiles/SPECIALREPORT/Review at a Glance.png": 1085,
	"./services_manager/four_tiles/SPECIALREPORT/Track Engagement": 1086,
	"./services_manager/four_tiles/SPECIALREPORT/Track Engagement.png": 1086,
	"./services_manager/google-play": 603,
	"./services_manager/google-play.svg": 603,
	"./services_manager/gray-left-arrow": 369,
	"./services_manager/gray-left-arrow.svg": 369,
	"./services_manager/gray-right-arrow": 439,
	"./services_manager/gray-right-arrow.svg": 439,
	"./services_manager/help": 1087,
	"./services_manager/help.svg": 1087,
	"./services_manager/home": 1088,
	"./services_manager/home.svg": 1088,
	"./services_manager/integration_partners/asiapay": 1089,
	"./services_manager/integration_partners/asiapay.png": 1089,
	"./services_manager/integration_partners/assessprep": 1090,
	"./services_manager/integration_partners/assessprep.png": 1090,
	"./services_manager/integration_partners/atlasnext": 1091,
	"./services_manager/integration_partners/atlasnext.png": 1091,
	"./services_manager/integration_partners/azure ad": 1092,
	"./services_manager/integration_partners/azure ad.png": 1092,
	"./services_manager/integration_partners/braintree": 1093,
	"./services_manager/integration_partners/braintree.png": 1093,
	"./services_manager/integration_partners/bridgeu": 1094,
	"./services_manager/integration_partners/bridgeu.png": 1094,
	"./services_manager/integration_partners/canvas": 1095,
	"./services_manager/integration_partners/canvas.png": 1095,
	"./services_manager/integration_partners/class charts": 1096,
	"./services_manager/integration_partners/class charts.png": 1096,
	"./services_manager/integration_partners/clever": 1097,
	"./services_manager/integration_partners/clever.png": 1097,
	"./services_manager/integration_partners/concord infiniti": 1098,
	"./services_manager/integration_partners/concord infiniti.png": 1098,
	"./services_manager/integration_partners/cybersource": 1099,
	"./services_manager/integration_partners/cybersource.png": 1099,
	"./services_manager/integration_partners/finalsite": 1100,
	"./services_manager/integration_partners/finalsite.png": 1100,
	"./services_manager/integration_partners/genesis": 1101,
	"./services_manager/integration_partners/genesis.png": 1101,
	"./services_manager/integration_partners/gg4l": 1102,
	"./services_manager/integration_partners/gg4l.png": 1102,
	"./services_manager/integration_partners/google": 1103,
	"./services_manager/integration_partners/google analytics": 1104,
	"./services_manager/integration_partners/google analytics.png": 1104,
	"./services_manager/integration_partners/google apps for education": 1105,
	"./services_manager/integration_partners/google apps for education.png": 1105,
	"./services_manager/integration_partners/google drive": 1106,
	"./services_manager/integration_partners/google drive.png": 1106,
	"./services_manager/integration_partners/google.png": 1103,
	"./services_manager/integration_partners/idat": 1107,
	"./services_manager/integration_partners/idat.png": 1107,
	"./services_manager/integration_partners/integrate with your sis via public api": 1108,
	"./services_manager/integration_partners/integrate with your sis via public api.png": 1108,
	"./services_manager/integration_partners/isams": 1109,
	"./services_manager/integration_partners/isams.png": 1109,
	"./services_manager/integration_partners/ldap": 1110,
	"./services_manager/integration_partners/ldap.png": 1110,
	"./services_manager/integration_partners/managebac": 1111,
	"./services_manager/integration_partners/managebac.png": 1111,
	"./services_manager/integration_partners/microsoft azure": 1112,
	"./services_manager/integration_partners/microsoft azure.png": 1112,
	"./services_manager/integration_partners/microsoft onedrive": 1113,
	"./services_manager/integration_partners/microsoft onedrive.png": 1113,
	"./services_manager/integration_partners/office 365": 1114,
	"./services_manager/integration_partners/office 365.png": 1114,
	"./services_manager/integration_partners/openapply": 1115,
	"./services_manager/integration_partners/openapply.png": 1115,
	"./services_manager/integration_partners/osc study": 1116,
	"./services_manager/integration_partners/osc study.png": 1116,
	"./services_manager/integration_partners/pamoja lesson suite": 1117,
	"./services_manager/integration_partners/pamoja lesson suite.png": 1117,
	"./services_manager/integration_partners/pamoja online courses": 1118,
	"./services_manager/integration_partners/pamoja online courses.png": 1118,
	"./services_manager/integration_partners/payfort": 1119,
	"./services_manager/integration_partners/payfort.png": 1119,
	"./services_manager/integration_partners/paysafe": 1120,
	"./services_manager/integration_partners/paysafe.png": 1120,
	"./services_manager/integration_partners/powerschool": 1121,
	"./services_manager/integration_partners/powerschool.png": 1121,
	"./services_manager/integration_partners/schoology": 1122,
	"./services_manager/integration_partners/schoology.png": 1122,
	"./services_manager/integration_partners/schoolsbuddy": 1123,
	"./services_manager/integration_partners/schoolsbuddy.png": 1123,
	"./services_manager/integration_partners/standard application online": 1124,
	"./services_manager/integration_partners/standard application online.png": 1124,
	"./services_manager/integration_partners/stripe": 1125,
	"./services_manager/integration_partners/stripe.png": 1125,
	"./services_manager/integration_partners/turnitin": 1126,
	"./services_manager/integration_partners/turnitin.png": 1126,
	"./services_manager/integration_partners/wechat": 1127,
	"./services_manager/integration_partners/wechat.png": 1127,
	"./services_manager/integration_partners/wonde": 1128,
	"./services_manager/integration_partners/wonde.png": 1128,
	"./services_manager/integration_partners/zoom": 1129,
	"./services_manager/integration_partners/zoom.png": 1129,
	"./services_manager/left-arrow": 1130,
	"./services_manager/left-arrow.svg": 1130,
	"./services_manager/link": 1131,
	"./services_manager/link.svg": 1131,
	"./services_manager/lock": 1132,
	"./services_manager/lock.svg": 1132,
	"./services_manager/logos/atlas_next": 616,
	"./services_manager/logos/atlas_next.png": 616,
	"./services_manager/logos/faria_one": 617,
	"./services_manager/logos/faria_one.png": 617,
	"./services_manager/logos/managebac": 618,
	"./services_manager/logos/managebac.png": 618,
	"./services_manager/logos/mb_chat": 619,
	"./services_manager/logos/mb_chat.png": 619,
	"./services_manager/logos/oa_crm": 620,
	"./services_manager/logos/oa_crm.png": 620,
	"./services_manager/logos/open_apply": 621,
	"./services_manager/logos/open_apply.png": 621,
	"./services_manager/logos/pamoja": 622,
	"./services_manager/logos/pamoja.png": 622,
	"./services_manager/logos/schools_buddy": 623,
	"./services_manager/logos/schools_buddy.png": 623,
	"./services_manager/mail": 1133,
	"./services_manager/mail.svg": 1133,
	"./services_manager/mail_grey": 604,
	"./services_manager/mail_grey.svg": 604,
	"./services_manager/main_banner_description_icons/Applicant Review": 624,
	"./services_manager/main_banner_description_icons/Applicant Review.png": 624,
	"./services_manager/main_banner_description_icons/Built for International Schools": 625,
	"./services_manager/main_banner_description_icons/Built for International Schools.png": 625,
	"./services_manager/main_banner_description_icons/Built-in Safeguarding": 626,
	"./services_manager/main_banner_description_icons/Built-in Safeguarding.png": 626,
	"./services_manager/main_banner_description_icons/CRM Analytics": 627,
	"./services_manager/main_banner_description_icons/CRM Analytics.png": 627,
	"./services_manager/main_banner_description_icons/Classes, Year Groups & Homerooms": 628,
	"./services_manager/main_banner_description_icons/Classes, Year Groups & Homerooms.png": 628,
	"./services_manager/main_banner_description_icons/Email Marketing Campaigns": 629,
	"./services_manager/main_banner_description_icons/Email Marketing Campaigns.png": 629,
	"./services_manager/main_banner_description_icons/Professional Development": 630,
	"./services_manager/main_banner_description_icons/Professional Development.png": 630,
	"./services_manager/main_banner_description_icons/Revision & Assessment": 631,
	"./services_manager/main_banner_description_icons/Revision & Assessment.png": 631,
	"./services_manager/main_banner_description_icons/Teaching & Learning": 632,
	"./services_manager/main_banner_description_icons/Teaching & Learning.png": 632,
	"./services_manager/main_banners/atlas_next": 633,
	"./services_manager/main_banners/atlas_next.png": 633,
	"./services_manager/main_banners/atlas_next_mobile": 634,
	"./services_manager/main_banners/atlas_next_mobile.png": 634,
	"./services_manager/main_banners/faria_one": 635,
	"./services_manager/main_banners/faria_one.png": 635,
	"./services_manager/main_banners/faria_one_mobile": 636,
	"./services_manager/main_banners/faria_one_mobile.png": 636,
	"./services_manager/main_banners/managebac": 637,
	"./services_manager/main_banners/managebac.png": 637,
	"./services_manager/main_banners/managebac_mobile": 638,
	"./services_manager/main_banners/managebac_mobile.png": 638,
	"./services_manager/main_banners/mb_chat": 639,
	"./services_manager/main_banners/mb_chat.png": 639,
	"./services_manager/main_banners/mb_chat_mobile": 640,
	"./services_manager/main_banners/mb_chat_mobile.png": 640,
	"./services_manager/main_banners/mb_passport": 641,
	"./services_manager/main_banners/mb_passport.png": 641,
	"./services_manager/main_banners/mb_passport_mobile": 642,
	"./services_manager/main_banners/mb_passport_mobile.png": 642,
	"./services_manager/main_banners/oa_crm": 643,
	"./services_manager/main_banners/oa_crm.png": 643,
	"./services_manager/main_banners/oa_crm_mobile": 644,
	"./services_manager/main_banners/oa_crm_mobile.png": 644,
	"./services_manager/main_banners/open_apply": 645,
	"./services_manager/main_banners/open_apply.png": 645,
	"./services_manager/main_banners/open_apply_mobile": 646,
	"./services_manager/main_banners/open_apply_mobile.png": 646,
	"./services_manager/main_banners/pamoja": 647,
	"./services_manager/main_banners/pamoja.png": 647,
	"./services_manager/main_banners/pamoja_mobile": 648,
	"./services_manager/main_banners/pamoja_mobile.png": 648,
	"./services_manager/main_banners/schools_buddy": 649,
	"./services_manager/main_banners/schools_buddy.png": 649,
	"./services_manager/main_banners/schools_buddy_mobile": 650,
	"./services_manager/main_banners/schools_buddy_mobile.png": 650,
	"./services_manager/paycheck": 605,
	"./services_manager/paycheck.png": 605,
	"./slide_icon": 1401,
	"./slide_icon.png": 1401,
	"./success": 1201,
	"./success.svg": 1201,
	"./systems-map-icons/FariaOne": 651,
	"./systems-map-icons/FariaOne.png": 651,
	"./systems-map-icons/ManageBacTitle": 652,
	"./systems-map-icons/ManageBacTitle.png": 652,
	"./systems-map-icons/OpenApplyTitle": 653,
	"./systems-map-icons/OpenApplyTitle.png": 653,
	"./systems-map-icons/SchoolsBuddyTitle": 654,
	"./systems-map-icons/SchoolsBuddyTitle.png": 654,
	"./systems-map-icons/account-portal/Azure AD": 1134,
	"./systems-map-icons/account-portal/Azure AD.png": 1134,
	"./systems-map-icons/account-portal/Google": 1135,
	"./systems-map-icons/account-portal/Google.png": 1135,
	"./systems-map-icons/account-portal/Office 365": 1136,
	"./systems-map-icons/account-portal/Office 365.png": 1136,
	"./systems-map-icons/accounts_portal": 655,
	"./systems-map-icons/accounts_portal.png": 655,
	"./systems-map-icons/community/101.Careers": 1325,
	"./systems-map-icons/community/101.Careers.png": 1325,
	"./systems-map-icons/community/Almabase": 1326,
	"./systems-map-icons/community/Almabase.png": 1326,
	"./systems-map-icons/community/BridgeU": 1327,
	"./systems-map-icons/community/BridgeU.png": 1327,
	"./systems-map-icons/community/Cialfo": 1328,
	"./systems-map-icons/community/Cialfo.png": 1328,
	"./systems-map-icons/community/Concourse": 1329,
	"./systems-map-icons/community/Concourse.png": 1329,
	"./systems-map-icons/community/Finalsite": 1330,
	"./systems-map-icons/community/Finalsite.png": 1330,
	"./systems-map-icons/community/Graduway": 1331,
	"./systems-map-icons/community/Graduway.png": 1331,
	"./systems-map-icons/community/PowerSchool": 1332,
	"./systems-map-icons/community/PowerSchool.png": 1332,
	"./systems-map-icons/community/ToucanTech": 1333,
	"./systems-map-icons/community/ToucanTech.png": 1333,
	"./systems-map-icons/community/Unifrog": 1334,
	"./systems-map-icons/community/Unifrog.png": 1334,
	"./systems-map-icons/community/WordPress": 1335,
	"./systems-map-icons/community/WordPress.png": 1335,
	"./systems-map-icons/community/generic/CMSMarketingPlatform Generic": 1137,
	"./systems-map-icons/community/generic/CMSMarketingPlatform Generic.png": 1137,
	"./systems-map-icons/community/generic/alumniAndFundraisingPlatform Generic": 1138,
	"./systems-map-icons/community/generic/alumniAndFundraisingPlatform Generic.png": 1138,
	"./systems-map-icons/community/generic/careersAndUniversityPlatform Generic": 1139,
	"./systems-map-icons/community/generic/careersAndUniversityPlatform Generic.png": 1139,
	"./systems-map-icons/community/generic/healthAndMedicalPlatform Generic": 1140,
	"./systems-map-icons/community/generic/healthAndMedicalPlatform Generic.png": 1140,
	"./systems-map-icons/community/generic/hostingPlatform Generic": 1141,
	"./systems-map-icons/community/generic/hostingPlatform Generic.png": 1141,
	"./systems-map-icons/community/iSAMS": 1336,
	"./systems-map-icons/community/iSAMS.png": 1336,
	"./systems-map-icons/exams-and-accreditation/Concierge": 1142,
	"./systems-map-icons/exams-and-accreditation/Concierge.png": 1142,
	"./systems-map-icons/exams-and-accreditation/IBIS": 1143,
	"./systems-map-icons/exams-and-accreditation/IBIS.png": 1143,
	"./systems-map-icons/exams-and-accreditation/eCoursework": 1144,
	"./systems-map-icons/exams-and-accreditation/eCoursework.png": 1144,
	"./systems-map-icons/key-integrations/ClassLink": 1337,
	"./systems-map-icons/key-integrations/ClassLink.png": 1337,
	"./systems-map-icons/key-integrations/Clever": 1338,
	"./systems-map-icons/key-integrations/Clever.png": 1338,
	"./systems-map-icons/key-integrations/EduTone (GG4L)": 1339,
	"./systems-map-icons/key-integrations/EduTone (GG4L).png": 1339,
	"./systems-map-icons/key-integrations/Engage": 1340,
	"./systems-map-icons/key-integrations/Engage.png": 1340,
	"./systems-map-icons/key-integrations/Google Data Studio": 1341,
	"./systems-map-icons/key-integrations/Google Data Studio.png": 1341,
	"./systems-map-icons/key-integrations/Google Workspace": 1342,
	"./systems-map-icons/key-integrations/Google Workspace.png": 1342,
	"./systems-map-icons/key-integrations/Microsoft Teams": 1343,
	"./systems-map-icons/key-integrations/Microsoft Teams.png": 1343,
	"./systems-map-icons/key-integrations/PowerBI": 1344,
	"./systems-map-icons/key-integrations/PowerBI.png": 1344,
	"./systems-map-icons/key-integrations/PowerSchool": 1345,
	"./systems-map-icons/key-integrations/PowerSchool Scheduler": 1346,
	"./systems-map-icons/key-integrations/PowerSchool Scheduler.png": 1346,
	"./systems-map-icons/key-integrations/PowerSchool.png": 1345,
	"./systems-map-icons/key-integrations/SchoolBase": 1347,
	"./systems-map-icons/key-integrations/SchoolBase.png": 1347,
	"./systems-map-icons/key-integrations/Timetabler.com": 1348,
	"./systems-map-icons/key-integrations/Timetabler.com.png": 1348,
	"./systems-map-icons/key-integrations/Untis": 1349,
	"./systems-map-icons/key-integrations/Untis.png": 1349,
	"./systems-map-icons/key-integrations/aSc Timetables": 1350,
	"./systems-map-icons/key-integrations/aSc Timetables.png": 1350,
	"./systems-map-icons/key-integrations/generic/SISMIS Generic": 1145,
	"./systems-map-icons/key-integrations/generic/SISMIS Generic.png": 1145,
	"./systems-map-icons/key-integrations/generic/collaborationAndEmail Generic": 1146,
	"./systems-map-icons/key-integrations/generic/collaborationAndEmail Generic.png": 1146,
	"./systems-map-icons/key-integrations/generic/dataAnalytics Generic": 1147,
	"./systems-map-icons/key-integrations/generic/dataAnalytics Generic.png": 1147,
	"./systems-map-icons/key-integrations/generic/dataSynchronisationService Generic": 1148,
	"./systems-map-icons/key-integrations/generic/dataSynchronisationService Generic.png": 1148,
	"./systems-map-icons/key-integrations/generic/timetables Generic": 1149,
	"./systems-map-icons/key-integrations/generic/timetables Generic.png": 1149,
	"./systems-map-icons/key-integrations/iSAMS": 1351,
	"./systems-map-icons/key-integrations/iSAMS.png": 1351,
	"./systems-map-icons/learning-and-teaching/AssessPrep": 1352,
	"./systems-map-icons/learning-and-teaching/AssessPrep.png": 1352,
	"./systems-map-icons/learning-and-teaching/Concord Infiniti": 1353,
	"./systems-map-icons/learning-and-teaching/Concord Infiniti.png": 1353,
	"./systems-map-icons/learning-and-teaching/DigiExam": 1354,
	"./systems-map-icons/learning-and-teaching/DigiExam.png": 1354,
	"./systems-map-icons/learning-and-teaching/Follett Destiny": 1355,
	"./systems-map-icons/learning-and-teaching/Follett Destiny.png": 1355,
	"./systems-map-icons/learning-and-teaching/Global Online Academy": 1356,
	"./systems-map-icons/learning-and-teaching/Global Online Academy.png": 1356,
	"./systems-map-icons/learning-and-teaching/In-House Revision Support": 1357,
	"./systems-map-icons/learning-and-teaching/In-House Revision Support.png": 1357,
	"./systems-map-icons/learning-and-teaching/Kahoot": 1358,
	"./systems-map-icons/learning-and-teaching/Kahoot.png": 1358,
	"./systems-map-icons/learning-and-teaching/Kognity": 1359,
	"./systems-map-icons/learning-and-teaching/Kognity.png": 1359,
	"./systems-map-icons/learning-and-teaching/ManageBac": 1360,
	"./systems-map-icons/learning-and-teaching/ManageBac.png": 1360,
	"./systems-map-icons/learning-and-teaching/Oliver": 1361,
	"./systems-map-icons/learning-and-teaching/Oliver.png": 1361,
	"./systems-map-icons/learning-and-teaching/Oxford Study Courses (OSC)": 1362,
	"./systems-map-icons/learning-and-teaching/Oxford Study Courses (OSC).png": 1362,
	"./systems-map-icons/learning-and-teaching/Padlet": 1363,
	"./systems-map-icons/learning-and-teaching/Padlet.png": 1363,
	"./systems-map-icons/learning-and-teaching/Pamoja": 1364,
	"./systems-map-icons/learning-and-teaching/Pamoja.png": 1364,
	"./systems-map-icons/learning-and-teaching/SeeSaw": 1365,
	"./systems-map-icons/learning-and-teaching/SeeSaw.png": 1365,
	"./systems-map-icons/learning-and-teaching/generic/onlineAssessmentPlatform Generic": 1150,
	"./systems-map-icons/learning-and-teaching/generic/onlineAssessmentPlatform Generic.png": 1150,
	"./systems-map-icons/learning-and-teaching/generic/onlineCoursePlatform Generic": 1151,
	"./systems-map-icons/learning-and-teaching/generic/onlineCoursePlatform Generic.png": 1151,
	"./systems-map-icons/learning-and-teaching/generic/onlineLibraryManagement Generic": 1152,
	"./systems-map-icons/learning-and-teaching/generic/onlineLibraryManagement Generic.png": 1152,
	"./systems-map-icons/learning-and-teaching/generic/onlineRevisionSupportForIBDPExternalAssessments Generic": 1153,
	"./systems-map-icons/learning-and-teaching/generic/onlineRevisionSupportForIBDPExternalAssessments Generic.png": 1153,
	"./systems-map-icons/learning-and-teaching/generic/portfolioPlatform Generic": 1154,
	"./systems-map-icons/learning-and-teaching/generic/portfolioPlatform Generic.png": 1154,
	"./systems-map-icons/managebac/Academic & Accreditation Standards": 1155,
	"./systems-map-icons/managebac/Academic & Accreditation Standards.png": 1155,
	"./systems-map-icons/managebac/Attendance": 1156,
	"./systems-map-icons/managebac/Attendance.png": 1156,
	"./systems-map-icons/managebac/Calendar & Deadlines": 1157,
	"./systems-map-icons/managebac/Calendar & Deadlines.png": 1157,
	"./systems-map-icons/managebac/Classroom Management & Communication": 1158,
	"./systems-map-icons/managebac/Classroom Management & Communication.png": 1158,
	"./systems-map-icons/managebac/Curriculum Planning": 1159,
	"./systems-map-icons/managebac/Curriculum Planning.png": 1159,
	"./systems-map-icons/managebac/Gradebook": 1160,
	"./systems-map-icons/managebac/Gradebook.png": 1160,
	"./systems-map-icons/managebac/Service Learning & PBL": 1161,
	"./systems-map-icons/managebac/Service Learning & PBL.png": 1161,
	"./systems-map-icons/openapply/Applicant Review Process": 1162,
	"./systems-map-icons/openapply/Applicant Review Process.png": 1162,
	"./systems-map-icons/openapply/Application Forms": 1163,
	"./systems-map-icons/openapply/Application Forms.png": 1163,
	"./systems-map-icons/openapply/Assessments and Interviews": 1164,
	"./systems-map-icons/openapply/Assessments and Interviews.png": 1164,
	"./systems-map-icons/openapply/Built-in Analytics": 1165,
	"./systems-map-icons/openapply/Built-in Analytics.png": 1165,
	"./systems-map-icons/openapply/MIS Integration": 1166,
	"./systems-map-icons/openapply/MIS Integration.png": 1166,
	"./systems-map-icons/openapply/Online Enquiry": 1167,
	"./systems-map-icons/openapply/Online Enquiry.png": 1167,
	"./systems-map-icons/openapply/Online Offers & Other Online Forms": 1168,
	"./systems-map-icons/openapply/Online Offers & Other Online Forms.png": 1168,
	"./systems-map-icons/openapply/Open Day and Tour Booking": 1169,
	"./systems-map-icons/openapply/Open Day and Tour Booking.png": 1169,
	"./systems-map-icons/openapply/Parent Communication & Messaging": 1170,
	"./systems-map-icons/openapply/Parent Communication & Messaging.png": 1170,
	"./systems-map-icons/openapply/Re-enrolment": 1171,
	"./systems-map-icons/openapply/Re-enrolment.png": 1171,
	"./systems-map-icons/operations/HR2000": 1366,
	"./systems-map-icons/operations/HR2000.png": 1366,
	"./systems-map-icons/operations/Microsoft Navision": 1367,
	"./systems-map-icons/operations/Microsoft Navision.png": 1367,
	"./systems-map-icons/operations/SAGE": 1368,
	"./systems-map-icons/operations/SAGE.png": 1368,
	"./systems-map-icons/operations/SAP": 1369,
	"./systems-map-icons/operations/SAP.png": 1369,
	"./systems-map-icons/operations/SchoolCloud": 1370,
	"./systems-map-icons/operations/SchoolCloud.png": 1370,
	"./systems-map-icons/operations/SchoolsBuddy": 1371,
	"./systems-map-icons/operations/SchoolsBuddy.png": 1371,
	"./systems-map-icons/operations/Schrole": 1372,
	"./systems-map-icons/operations/Schrole.png": 1372,
	"./systems-map-icons/operations/Xero": 1373,
	"./systems-map-icons/operations/Xero.png": 1373,
	"./systems-map-icons/operations/generic/accountingAndFinancePlatform Generic": 1172,
	"./systems-map-icons/operations/generic/accountingAndFinancePlatform Generic.png": 1172,
	"./systems-map-icons/operations/generic/recruitmentPlatform Generic": 1173,
	"./systems-map-icons/operations/generic/recruitmentPlatform Generic.png": 1173,
	"./systems-map-icons/operations/generic/roomBookingPlatform Generic": 1174,
	"./systems-map-icons/operations/generic/roomBookingPlatform Generic.png": 1174,
	"./systems-map-icons/operations/iFinance": 1374,
	"./systems-map-icons/operations/iFinance.png": 1374,
	"./systems-map-icons/schools-buddy/Activities Management": 1175,
	"./systems-map-icons/schools-buddy/Activities Management.png": 1175,
	"./systems-map-icons/schools-buddy/Event, Sport & Trip Management": 1176,
	"./systems-map-icons/schools-buddy/Event, Sport & Trip Management.png": 1176,
	"./systems-map-icons/schools-buddy/Online Payments": 1177,
	"./systems-map-icons/schools-buddy/Online Payments.png": 1177,
	"./systems-map-icons/schools-buddy/Parent Communications": 1178,
	"./systems-map-icons/schools-buddy/Parent Communications.png": 1178,
	"./systems-map-icons/schools-buddy/Parent Teacher Conferences": 1179,
	"./systems-map-icons/schools-buddy/Parent Teacher Conferences.png": 1179,
	"./systems-map-icons/schools-buddy/SchoolsBuddy-logo": 1180,
	"./systems-map-icons/schools-buddy/SchoolsBuddy-logo.png": 1180,
	"./systems-map-icons/schools-buddy/Transport System": 1181,
	"./systems-map-icons/schools-buddy/Transport System.png": 1181,
	"./systems-map-icons/welcome-page/system_map_questionnaire_banner_mobile": 1182,
	"./systems-map-icons/welcome-page/system_map_questionnaire_banner_mobile.png": 1182,
	"./systems-map-icons/welcome-page/system_map_questionnaire_banner_web": 1183,
	"./systems-map-icons/welcome-page/system_map_questionnaire_banner_web.png": 1183,
	"./tick": 1424,
	"./tick.svg": 1424,
	"./trash": 606,
	"./trash.svg": 606,
	"./warning": 1425,
	"./warning.svg": 1425,
	"./white-clock": 1202,
	"./white-clock.svg": 1202,
	"./white-cross": 307,
	"./white-cross.svg": 307,
	"./white-mail": 659,
	"./white-mail.svg": 659
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1389;